/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from "react";
import { Link } from 'react-router-dom';
import Axios from 'axios';
import { Button, Form, Modal, Row, Col, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import Table from 'react-bootstrap/Table';
import Mir from "./Mir";
import GD from "./GD";
// project imports
import { getSellerUrl, getSellerHeaders, getPaymentHeader, getPaymentUrl, getAlertSSEUrl } from 'shared/http';
import {
    itemlist, itemstatusbysale, salesDashboard, generateInvoice, categorynewlist, saledetail, generateEmail, itemStatusUpdate, itemstatusbulkupdate, invoiceList, itemimagelist, itemsync, itemcloseorder, taxexemptlist, taxexemptbuyer, itemdelete, processPayment, checkitemtaxzero, sellerToPaymentToken,
    paymentStatusSseEvent, paymentLocationSseEvent, singleProcessPayment, invoicePendingProcessPayment, transactionHistory, saleDashboardSseEvent, pickuptime, quote,fullFillmentList,itemBulkUpdate,
    salelist, locationlist,emailBounceView
} from 'shared/settings/apiconfig';
import store from 'features/store';
import Notes from './Notes';
import { ToasterMessage } from 'shared/toast/toast';
import { addDataLayer, navigateToHelpCenter } from 'shared/utils/utils';
import { capitalizeFirstLetter } from "shared/utils";
import DatePicker from "react-datepicker";
// style imports
import './SalesDashboard.scss';
import { ACCESS_TOKEN, getPayload } from "shared/settings/token";
import { responseCodeAndStatus } from "../invoice/DeclinedCardStatus";
import { Fullfillment } from "../fullfillment/Fullfillment";
import FullfillmentList from "./FullFillmentlist";
import { NoData } from "features/components/redirect/NoData";
import PickupItems from "./PickupItems";


/**
 * this page is used to show sale dashboard
 * 
 * @param props
 * 
 * @return Sales dashboard html
 * 
**/

export class SalesDashboard extends Component {
    category;
    constructor(props) {
        super(props);
        this.dataTable = createRef();
        this.ScrollRef = createRef();  
        this.mirtable = createRef();
        this.timeoutInterval = {};
        this.invoiceSearch = {
            invoicenumber: { field: 'invoicenumber', value: '', op: 'LIKE', join: 'AND' },
            itemtitle: { field: 'itemtitle', value: '', op: 'LIKE', join: 'AND' },
            emailsent: { field: 'emailsent', value: '', op: '=', join: 'AND' },
            invoicestatus: { field: 'invoicestatus', value: '', op: '=', join: 'AND' },
            buyeremail: { field: 'buyeremail', value: '', op: 'LIKE', join: 'AND' },
            firstname: { field: 'firstname', value: '', op: 'LIKE', join: 'AND' },
            lastname: { field: 'lastname', value: '', op: 'LIKE', join: 'AND' },
            autoDebitStatus: { field: 'autoDebitStatus', value: '', op: '=', join: 'AND' },
            bidderacceptance: { field: 'bidderacceptance', value: '', op: '=', join: 'AND' },
            receivedamount: { field: "receivedamount", value: '', op: ">", join: "AND" },
            pendingamount: { field: "pendingamount", value: '', op: "=", join: "OR" },
            pendingamountreceievd: { field: "pendingamount", value: '', op: "!=", join: "AND" },
            irm: {field: 'bidderirm', value: '', op: "LIKE", join: "AND"},
            mirstatus: {field: 'mirstatus', value: '', op: "!=", join: "AND"},
            type: {field: 'type', value: '', op: "=", join: "AND"}
        }
        this.itemSearch = {
            categoryid: { field: 'category', value: '', op: '=', join: 'AND' },
            title: { field: 'title', value: '', op: 'LIKE', join: 'AND' },
            SKU: { field: 'SKU', value: '', op: 'LIKE', join: 'AND' },
            description: { field: 'description', value: '', op: 'LIKE', join: 'AND' },
            categoryGroup : { field: 'categoryGroup', value: '', op: '=', join: 'AND' }

        }
        const dashboardState = props?.location?.state?.state;
        const restoredActive = dashboardState ? dashboardState.active : 'all-items';
        this.pressCount = dashboardState ? dashboardState.pressCount : 1

        this.state = {
            isLocked: '',
            startDate: new Date(),
            endDate: new Date(),
            locationList: [],
            saleAllList: [],
            selectLocationId: '',
            active: restoredActive,
            salesId: this.props.match.params.salesId,
            filter: [
                {
                    field: "saleid",
                    value: this.props.match.params.salesId,
                    op: "=",
                    join: "AND"
                },
                {
                    field: "",
                    value: "",
                    op: "=",
                    join: "AND"
                },
                // {
                //     field: "itemtypeid",
                //     value: "2",
                //     op: "=",
                //     join: "AND"
                // }
            ],
            categoryMenuName: '',
            statusMessage: '',
            applytaxonbp: '',
            sort: dashboardState ? dashboardState.sort : [{ "field": "title", "direction": "asc" }],
            titlesortValue: dashboardState ? dashboardState.titlesortValue : "asc",
            skusortValue: dashboardState ? dashboardState.skusortValue : "",
            dropdownselect: dashboardState ? dashboardState.dropdownselect : '',
            searchData: true,
            tableData: [],
            category: [],
            tableTotal: '',
            pageLoading: dashboardState ? dashboardState.pageLoading : true,
            allCounts: dashboardState ? dashboardState.allCounts : {},
            allItems: 0,
            shippingDeliveryDropdown: dashboardState ? dashboardState.shippingDeliveryDropdown || this.isShippingDeliveryOption(restoredActive) : false,
            alert_height: 55,
            error: false,
            modal: false,
            invoiceGenerated: this.props.location?.state?.saletitle?.invoicegenerated > 0 ? true : false,
            selectedList: [],
            selectedType: props?.location?.state?.state ? props?.location?.state?.state.selectedType : '',
            statusType: "",
            changeStatusValue: '',
            itemTax: '',
            itemBp: '',
            itemStatus: '',
            itemistaxable: false,
            selectedButton: "",
            statusChangeModal: false,
            salesDashboardStatus: { show: false, type: '', message: '' },
            soldList: 0,
            itemStatusChanged: false,
            loaderForMore: false,
            nextList: null,
            itemList: props?.location?.state?.state ? props?.location?.state?.state?.itemList : [],
            messageList: [],
            messageselected: false,
            loading: false,
            itemStatusToast: { show: false, type: '', message: '' },
            saleDetail: {},
            endtime: "",
            status: "",
            issoldList: false,
            moreData: "",
            moreModal: false,
            invoiceSearch: props?.location?.state?.state ? props?.location?.state?.state?.invoiceSearch : this.invoiceSearch,
            itemSearch: props?.location?.state?.state ? props?.location?.state?.state?.itemSearch : this.itemSearch,
            invoicelist: props?.location?.state?.state ? props?.location?.state?.state?.invoicelist : [],
            invoiceModal: false,
            sendInvoiceOption: "unpaid-invoice",
            itemViewModal: false,
            itemListData: [],
            btnload: false,
            totalCount: props?.location?.state?.state ? props?.location?.state?.state?.totalCount : 0,
            itemViewLoader: null,
            pageCount: 100 * this.pressCount,
            pressCount: this.pressCount,
            name: "Saledashboard",
            scrollToIndex: props?.location?.state?.state ? props?.location?.state?.state?.scrollToIndex : 0,
            isBackHandle: props?.location?.state?.state ? true : false,
            maintain: props?.location?.state?.state ? props?.location?.state?.state?.maintain : props?.location?.state,
            windowWidth: window.innerWidth,
            invoiceDisableButton: false,
            sendDisablebutton: false,
            Local_saleid: '',
            Local_saletitle: '',
            itemcloseorderValue: [],
            ClosingDiasbleValue: [],
            ClosingOrderList: [],
            SelectedClosingid: [],
            SelectedClosingValue: '',
            ClosingOrderModal: false,
            SyncButtonEnable: false,
            selectedInvoiceList: [],
            selectedInvoice: [],
            selectedInvoiceType: "",
            invaliddata: { show: false, invaliddata: [] },
            pendingTaxExemption: [],
            ClosingorderOption: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
            printAllInvoiceList: [],
            processPaymentDisableButton: false,
            deleteModal: false,
            deleteLoading: false,
            scrollTo: 0,
            TaxExemptModal: false,
            locationId: null,
            saledetails: this.props.location?.state?.saletitle,
            transactionModalShow: false,
            transactionData: '',
            fullfillmentstatus: false,
            fullFillmentData: [],
            transactionLoader: false,
            selectedPrint: false,
            invoiceview: 0,
            pikcupDateModel: false,
            pickupTimeLoading: false,
            pickupTimeMsg: '',
            pickupTimeErrMsg: { show: false, type: '', message: '' },
            salePickupDate: new Date(),
            currentDate: new Date(),
            checkPickupDate: true,
            mirFilter:  this.props?.location?.state?.state?.mirFilter ? this.props?.location?.state?.state?.mirFilter : [],
            mirstatus: this.props?.location?.state?.mirstatus ? this.props?.location?.state?.mirstatus : false,
            fullfillmentStatus: false,
            ViewItemHandleStatus: false,
            pickupdate: new Date(),
            mirStatus: false,
            pickupdate: new Date(),
            fullFillmentFilter: this.props?.location?.state?.state?.fullFillmentFilter ? this.props.location.state.state.fullFillmentFilter : [],
            viewItemsInvoiceType: '',
            setStatusValue: '',
            emailBounceModel: false,
            emailbounceLoader: false,
            emailBounceData:[],
            saleitemreceiptmethod: {  pickup: false,  delivery: false,  shipping: false  },
            selectAllMessage: '',
            salesList: [] ,
            selectedSale: "",
            bulkValid: false,
            showSale: false,
            checkSelectAll: false,
            errorpageredirect: false,
            errorType: '',
            saleShippingSaint: ''
        };


        this.statusList = {
            buyerspremium: "Buyer's Premium Percentage",
            istaxable: "Item Taxable Status",
            itemreceiptmethod: "Item Receipt Method",
            sale: "Reassign Sale",
            status: "Status Change",
            tax: "Tax Percentage"
        };
        
        this.inactive = ['pending', 'shipped', 'available']
        this.timer = null;
        this.approveBack = false
        this.eventTypeMapping = {
            "Direct buy": "direct-buy",
            "Auction": "auction",
            "Onsite": "onsite-only",
            "Sold": "bought",
            "Not Sold": "notsold",
            "Ready": "available",
            "Pending": "pending"
        }
    }

    // Hide sidebar 
    componentDidMount() {

        store.dispatch({ type: 'SET_SIDEBAR', payload: false });
        this.setState({ loading: true });
        window.addEventListener('resize', this.getwindowwidth);
        // this.getPaymentKey()
        this.getSaleDetail();
        if (this.state.active === 'invoiced' || this.state.active === 'shipped') {
            /***************************************************** */
            /***** Load the invoiceList data from the state   **** */
            /***************************************************** */
            this.getinvoicelist();
            this.getCountForLeft();

            /***************************************************** */
        }
        else {
            this.getCategoryList();
            if (!this.props?.location?.state?.state) {
                this.getRequiredData();
            }
            else {
                /***************************************************** */
                /***** Load the itemList data from the state Starts  **** */
                /***************************************************** */
                this.setState({
                    nextList: this.props?.location?.state?.state?.nextList,
                    loaderForMore: false,
                    scrollTo: this.props?.location?.state?.state?.scrollTo,
                    selectedList : this.props?.location?.state?.state?.selectedList,
                    pageCount: this.state.pageCount
                }, () => {
                    // this.getRequiredData();
                    this.setState({
                        itemList: this.props?.location?.state?.state?.itemList,
                        loading: false
                    }, () => {
                        this.ScrollRef.current.scrollTo({ top: this.state.scrollTo, left: 0 });
                    });
                });
                if (this.props?.location?.itemEdit) // If the item/sale is Edited, will get the particular row from the api
                {
                    let filter = [{ field: "id", value: this.props?.location?.itemid, op: "=", join: "AND" }];
                    let data = {
                        "filter": filter,
                        "field": ["id", "displayimageurl", "title", "itemstatus", "description", "SKU", "category", "isshippable", "istaxable",
                            "isfeatured", "itemclosetime", "currentbidprice", "itemsoldprice", "closingorder", "details", "createddate", "isdisplayimage", "salestatus", "thumbnailurl","soldprice"]
                    };
                    axios.post(getSellerUrl(`${itemlist}`, {}), JSON.stringify(data), getSellerHeaders())
                        .then((response) => {
                            if (response.status === 200) {
                                let itemObj = response.data?.data;
                                let itemUpdatedObject = this.props?.location?.state?.state?.itemList.map(obj => itemObj.find(o => o.id === obj.id) || obj);
                                this.setState({
                                    itemList: this.props?.location?.itemEdit ? itemUpdatedObject : this.props?.location?.state?.state?.itemList,
                                })
                            }
                        });

                }
                /***************************************************** */
                /***** Load the itemList data from the state Ends  **** */
                /***************************************************** */


            }
            // this.getSaleDetail();
            this.getItemList();
        }
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
        localStorage.setItem('local_closedstatus', this.state.status)
        this.getAllInvoice();
        this.alertSseEventListener();
    }


    clickEventCheck = (data)=> {
        if(data.status == "Click") {
            return(
                <a style={{color: 'blue'}} href={data.reason} target="_blank" rel="noopener noreferrer">
                {data.reason} 
            </a>
            );
        }
        else{
            return data.reason
        }
    }
    emailValidation = (data) => {
        return (
            data.map((email, index) => (
                <p key={index}>
                    <span>{email}</span>
                </p>
            ))
        );
    };

    /* SSE Alert Event  */
    alertSseEventListener = () => {
        try {
            const saleid = "saleId=" + this.state.salesId;
            let now = moment().format('DD-MM-YYYY-HH-mm-ss');
            now = now ? now.replace(/-/g, '') : Math.floor(100000 + Math.random() * 900000);
            const number = Math.floor(100000 + Math.random() * 900000);
            const clientId = now + number.toString();

            this.eventSource = new EventSource(`${getAlertSSEUrl(saleDashboardSseEvent)}${clientId}?${saleid}`);
            this.eventSource.onmessage = (event) => this.sseMenuCountChange(event);
            this.eventSource.onopen = (event) => this.postAlertCall(event, clientId);
            this.eventSource.onerror = (event) => console.clear();
        } catch (e) {
        }
    }

    sseMenuCountChange = (event) => {
        let eventData = JSON.parse(event.data);
        if(eventData.type == "item_count") {
            let changedItems = []
            let total = eventData['Auction'] + eventData['Direct buy'] + eventData['Onsite'];
            if (this.state.totalCount && total && this.state.totalCount != total) {
                changedItems.push("all-items");
            }
            for (const count in this.state.allCounts) {
                if (typeof eventData[count] != "undefined" && this.state.allCounts[count] != eventData[count] && this.state.active != 'invoiced' && this.state.active != 'shipped') {
                    if(count in this.eventTypeMapping) {
                        changedItems.push(this.eventTypeMapping[count])
                    }
                }
            }
            if (changedItems.includes(this.state.active)) {
                this.setState({
                    loading: true
                }, () => {
                    this.getRequiredData(false, true);
                })
            }        
            this.setState({
                allCounts: {
                    ...this.state.allCounts,
                    'Ready': eventData["Ready"], 
                    'Sold': eventData["Sold"], 
                    'Not Sold': eventData['Not Sold'],
                    'Pending': eventData["Pending"], 
                    'Auction': eventData["Auction"], 
                    'Direct buy': eventData["Direct buy"], 
                    'Onsite': eventData["Onsite"],
                    'Mir': eventData["Mir"]
                },
                totalCount: total
            })
        }
        else if(eventData.type == "item_shipped_count") {
             let ssTotalCount = eventData['Shipped'] + eventData['Delivery'] + eventData['Pickup']

            this.setState({
                allCounts: {
                    ...this.state.allCounts,
                    'Shipped': eventData["Shipped"] || 0,
                    'Delivery': eventData["Delivery"] || 0,
                    'Pickup': eventData["Pickup"] || 0,
                },
                shippedTotalCount :ssTotalCount
            })
        }
        else if(eventData.type == "item_shipped_count") {
            for (const count in this.state.allCounts) {
                if (this.state.allCounts[count] != eventData[count] && this.state.active == "shipped") {
                    this.setState({
                        loading: true
                    }, () => {
                        this.getinvoicelist();
                    })
                    break
                }
            }
            this.setState({
                allCounts: {
                    ...this.state.allCounts,
                    'Shipped': eventData["Shipped"]
                }
            })
        }
        else if(eventData.type == "invoice_count") {
            for (const count in this.state.allCounts) {
                if (this.state.allCounts[count] != eventData[count] && this.state.active == 'invoiced') {
                    this.setState({
                        loading: true
                    }, () => {
                        this.getinvoicelist();
                    })
                    break
                }
            }
            this.setState({
                allCounts: {
                    ...this.state.allCounts,
                    'Invoiced': eventData["Invoiced"]
                }
            })
        }
        else if(eventData.type == "invoice_data") {
            let responseData = JSON.parse(event.data);
            let eventData = responseData.data;
            let invoiceData = this.state.invoicelist;
            eventData.forEach(data => {
                let index = invoiceData.findIndex(elem => elem.id == data.id)
                if (index != -1) {
                    if (data.autoDebitStatus) {
                        invoiceData[index]['autoDebitStatus'] = data.autoDebitStatus;
                    }
                    if (data.invoicestatus) {
                        invoiceData[index]['invoicestatus'] = data.invoicestatus;
                    }
                    if (typeof data.pendingamount !== "undefined" && data.pendingamount != null) {
                        invoiceData[index]['pendingamount'] = data.pendingamount;
                    }
                    if (data.bidderacceptance) {
                        invoiceData[index]['bidderacceptance'] = data.bidderacceptance;
                    }
                }
            });
            this.setState({
                invoicelist: invoiceData
            })
        }
        else if (eventData.type == "sale_close") {
            let responseData = eventData.data;
            this.setState({
                status: responseData['status']
            })
        }
        else if (eventData.type == "item_current_bid") {
            let responseData = eventData.data;
            let itemData = this.state.itemList;
            responseData.forEach(data => {
                let index = itemData.findIndex(elem => elem.id == data.itemid)
                itemData[index]['currentbidprice'] = data.bidprice
            })
            this.setState({
                itemList: itemData
            })
        }
    }

    postAlertCall = () => {
        console.log("success")
    }

    /* SSE Event  */
    sseEventListener = () => {
        try {
            // const temp = "item=" + this.itemId;
            let now = moment().format('DD-MM-YYYY-HH-mm-ss');
            now = now ? now.replace(/-/g, '') : Math.floor(100000 + Math.random() * 900000);
            const number = Math.floor(100000 + Math.random() * 900000);
            const clientId = now + number.toString();

            this.eventSource = new EventSource(`${getPaymentUrl(paymentStatusSseEvent)}${clientId}`);
            this.eventSource.onmessage = (event) => this.sseMessage(event);
            this.eventSource.onopen = (event) => this.postCall(event, clientId);
            this.eventSource.onerror = (event) => console.clear();
        } catch (e) {
        }
    }

    sseMessage = (event) => {
        let eventData = JSON.parse(event.data);
        if (eventData.invoiceId) {
            let invoiceData = this.state.invoicelist;
            eventData.invoiceId.forEach(data => {
                let index = invoiceData.findIndex(elem => elem.id == data)
                invoiceData[index]['autoDebitStatus'] = eventData.status;
                if (eventData.invoice_status) {
                    invoiceData[index]['invoicestatus'] = eventData.invoice_status;
                }
                if (typeof eventData.pending_amount !== "undefined" && eventData.pending_amount != null) {
                    invoiceData[index]['pendingamount'] = eventData.pending_amount;
                }
            });
            this.setState({
                invoicelist: invoiceData
            })
        }
    }

    postCall = (event, clientId) => {
        let payload = getPayload(ACCESS_TOKEN);
        axios.post(getPaymentUrl(`${paymentLocationSseEvent}${clientId}`), { data: { "location": payload.location } }, getPaymentHeader(this.state.sellerPaymentToken)).then(response => {
            if (response.data.status.toLowerCase() === 'success') {
            }
        }).catch(error => {
        });
    }

    // getPaymentKey() {
    //     axios.get(getSellerUrl(`${sellerToPaymentToken}`), getSellerHeaders()).then(response => {
    //         if (response.data.status.toLowerCase() === 'success') {
    //             this.setState({
    //                 sellerPaymentToken: response.data.accessToken
    //             })
    //         }
    //     }).catch(error => { });
    // }

    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.navigateToList();
        }
    }
    /* Get category list */
    getCategoryList = () => {
        axios.get(getSellerUrl(categorynewlist), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    let category = response.data.data.data[0]
                    Object.values(category).map((item) => {
                        return item.sort()
                    })
                    this.setState({
                        ...this.state,
                        category,
                    });
                }
            })
            .catch(error => {
                this.setState({
                    cloneStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                });
            });
    }
    //custom item Status button
    itemStatusButton() {
        if (this.state.active.includes('available') || this.state.active.includes('pending'))
            return (
                <div className="d-flex">
                    <Button style={{ marginTop: "5%", width: "160px", fontSize: 12, }}  disabled={(this.state.status.toLowerCase() === 'closed' ) || this.state.selectedList.length === 0}

                        onClick={() => {
                            this.setState({
                                statusChangeModal: true,
                                selectedButton: "all",
                                statusType: this.state.selectedType === 'Ready' ? 'Pending' : 'Ready'
                            })
                        }}>Item Bulk Update</Button>
                    {/* <Button style={{ marginLeft: "5%", marginTop: "5%", width: "160px", fontSize: 12 }}
                        disabled={this.state.selectedType === "" || this.state.selectedList.length === 0 || this.state.status.toLowerCase() === 'closed' || !((this.state.active.includes('available') && this.state.allCounts['Ready'] && this.state.allCounts['Ready'] > 0) || (this.state.active.includes('pending') && this.state.allCounts['Pending'] && this.state.allCounts['Pending'] > 0))}
                        onClick={() => {
                            this.setState({
                                statusChangeModal: true,
                                selectedButton: "individual",
                                statusType: this.state.selectedType === 'Ready' ? 'Pending' : 'Ready'
                            })
                        }} >Item Status Change</Button> */}
                </div>
            )
    }
    //checkbox
    checkBox(values, list) {
        var check = list.findIndex(item => item === values["id"]) > -1 ? true : false
        if (!(values["itemstatus"].includes("Sold")) && this.state.status.toLowerCase() !== 'closed' && (this.state.active.includes('available') || this.state.active.includes('pending')))
            return (
                <div>
                    <div style={{
                        backgroundColor: check ? "#9f2340" : "white",
                        width: "20px", height: "20px",
                        paddingLeft: "3px",
                        paddingTop: "2px"
                    }} className={`custom-checkbox-div ${check && 'checked'}`}
                        type="checkbox" name="itemChangeBox" checked={check} label="" onClick={() => this.onChangeCheckBox(values)} />
                </div>
            )
        else
            return null
    }
    //item status
    itemStatus(values, type) {
        return (
            <div style={{ color: (type === "" || values["itemstatus"] === type) ? "black" : "gray" }}> {values["itemstatus"]}</div>
        )
    }

    onChangeInvoiceCheckBox(value, from) {
        let selectedInvoiceType = this.state.selectedType;
        let selectedInvoice = this.state.selectedList;
        if (selectedInvoiceType === "") {
            selectedInvoiceType = value.itemstatus;
        }
        let index = selectedInvoice.indexOf(value.id);
        if (index >= 0) {
            selectedInvoice.splice(index, 1);
        }
        else {
            if (selectedInvoiceType === value.itemstatus) {
                selectedInvoice.push(value.id);
            }
        }
        if (selectedInvoice.length === 0) {
            selectedInvoiceType = "";
        }
        this.setState({
            selectedInvoiceType,
            selectedInvoice
        })
        if (from === 'invoice' && value.type !== 'RA' && value.type !== 'DG') {
            let { selectedInvoiceList } = this.state
            const index = selectedInvoiceList.findIndex(x => x.id === value.id);
            if (index >= 0) {
                selectedInvoiceList.splice(index, 1);
            }
            else {
                selectedInvoiceList.push(value);
            }
            this.setState({
                selectedInvoiceList,
            })
        }

    }

    onChangeCheckBox(value, from) {
        let selectedType = this.state.selectedType;
        let selectedList = this.state.selectedList;
        if (selectedType === "") {
            selectedType = value.itemstatus;
        }
        let index = selectedList.indexOf(value.id);
        if (index >= 0) {
            selectedList.splice(index, 1);
        }
        else {
            if (selectedType === value.itemstatus) {
                selectedList.push(value.id);
            }
        }
        if (selectedList.length === 0) {
            selectedType = "";
        }
        this.setState({
            selectedType,
            selectedList,
            selectAllMessage: selectedList.length == 100  ? "All 100 Items In This Page Is Selected Click More Below To Select More Items" : '',
       })

    }

    editAction = (values) => {
        return values['itemstatus'].toLowerCase() !== 'sold' && values['itemstatus'].toLowerCase() !== 'not sold';
    };

    getRequiredData = (append = false, fromEvent = false) => {
        let filter = [];
        filter = Object.values(this.state.itemSearch).filter(item => item.value !== "")
        filter = filter.map(item => { return ({ ...item, value: item.op !== "=" ? `*${item.value}*` : item.value }) })
        filter.push({ field: 'saleid', value: this.props.match.params.salesId, op: '=', join: 'AND' })
        filter.push({ field: 'isDeleted', value: 1, op: '!=', join: 'AND' })
        // filter.push({ field: "", value: "", op: "=", join: "AND" })
        if (this.state.active === 'direct-buy') {
            filter.push({ field: 'itemtypeid', value: 1, op: '=', join: 'AND' });
        }
        if (this.state.active === 'auction') {
            filter.push({ field: 'itemtypeid', value: 2, op: '=', join: 'AND' });
        }
        if (this.state.active === 'onsite-only') {
            filter.push({ field: 'itemtypeid', value: 3, op: '=', join: 'AND' });
        }
        if (this.state.active === 'bought') {
            filter.push({ field: 'itemstatus', value: "Sold", op: '=', join: 'AND' });
        }
        if (this.state.active === 'notsold') {
            filter.push({ field: 'itemstatus', value: "Not Sold", op: '=', join: 'AND' });
        }
        if (this.state.active === 'available') {
            filter.push({ field: 'itemstatus', value: "Ready", op: '=', join: 'AND' });
        }
        if (this.state.active === 'pending') {
            filter.push({ field: 'itemstatus', value: "Pending", op: '=', join: 'AND' });
        }
        let sort = [...this.state.sort]
        var data = {
            "sort": sort,
            "filter": filter,
            "page": append && this.state.nextList ? { "size": this.state.pageCount, next: this.state.nextList } : { "size": this.state.pageCount },
            "field": ["id", "displayimageurl", "title", "itemstatus", "description", "SKU", "category", "isshippable", "istaxable", "isdisplayimage",
                "isfeatured", "itemclosetime", "currentbidprice", "itemsoldprice", "closingorder", "details", "createddate", "salestatus", "thumbnailurl","soldprice"]
        };
        axios.post(getSellerUrl(`${itemlist}`, {}), JSON.stringify(data), getSellerHeaders())
            .then((response) => {
                if (response.status === 200) {
                    response = response.data;
                    let itemlistids =   response.data.map(item => item.id) 
                    const tempList = append ? this.state.itemList.concat(response.data) : response.data;
                    const itemIdlist = append && this.state.checkSelectAll ? this.state.selectedList.concat(itemlistids) : this.state.selectedList 
                    const pageNext = response.page && response.page.keyset && response.page.keyset.next ? response.page.keyset.next : null;
                    let getsoldlistInItem = response.data.filter(item => item.itemstatus === "Sold")
                    setTimeout(() => {
                        this.setState({
                            selectedList : itemIdlist,
                            itemList: tempList,
                            nextList: pageNext,
                            loaderForMore: false,
                            // loading: false,
                            issoldList: getsoldlistInItem.length > 0,
                            pageCount: 100,
                        }, () => {
                            if(!fromEvent) {
                                this.getCountForLeft();
                            }
                            let valuefromapi = []
                            // We dont need this api to be called for each pagination as it will take all closing order for items at first time itself 
                            if (this.state.itemList.length > 0 && this.state.active === 'available' && !append) {
                                const selectedValuesData = {
                                    "sort": sort,
                                    "filter": filter,
                                    "field": ["id", "closingorder", "isdisplayimage"],
                                    "page": { "size": this.state.totalCount }
                                }
                                axios.post(getSellerUrl(`${itemlist}`, {}), JSON.stringify(selectedValuesData), getSellerHeaders()).then(
                                    selectedValues => {
                                        const closingorderValues = selectedValues?.data?.data;
                                        const tempValue = closingorderValues.filter(x => x.closingorder !== 999);
                                        if (tempValue.length > 0) {
                                            tempValue.map(item => {
                                                let { ClosingDiasbleValue } = this.state
                                                let array_data = {
                                                    'id': item.id.toString(),
                                                    'selectedValue': item.closingorder.toString()
                                                }
                                                ClosingDiasbleValue.push(array_data)
                                                valuefromapi.push(item.closingorder.toString())
                                                const ids = ClosingDiasbleValue.map(o => o.id)
                                                const filtered = ClosingDiasbleValue.filter(({ id }, index) => !ids.includes(id, index + 1))
                                                this.setState({
                                                    itemcloseorderValue: valuefromapi,
                                                    ClosingDiasbleValue: filtered
                                                });
                                            });
                                        } else {
                                            this.setState({
                                                itemcloseorderValue: [],
                                                ClosingDiasbleValue: []
                                            });
                                        }
                                        this.setState({ loading: false });
                                    }
                                ).catch(error => {
                                    this.state.itemList.map((item, index) => {
                                        let { ClosingDiasbleValue } = this.state
                                        let array_data = {
                                            'id': item.id.toString(),
                                            'selectedValue': item.closingorder.toString()
                                        }
                                        ClosingDiasbleValue.push(array_data)
                                        valuefromapi.push(item.closingorder.toString())
                                        const ids = ClosingDiasbleValue.map(o => o.id)
                                        const filtered = ClosingDiasbleValue.filter(({ id }, index) => !ids.includes(id, index + 1))
                                        this.setState({
                                            itemcloseorderValue: valuefromapi,
                                            ClosingDiasbleValue: filtered
                                        });
                                    });
                                    this.setState({ loading: false });
                                    console?.clear()
                                });

                                // this.setState({loading: false});
                            } else {
                                this.setState({ loading: false });
                            }
                            // this.getItemList();
                            // this.getSaleDetail();
                        });
                    });
                    if (this.state.isBackHandle) {
                        setTimeout(() => {
                            const id = `items_${this.state.scrollToIndex}`
                            const divElement = document.getElementById(id)
                            divElement?.scrollIntoView({ behavior: "auto" });
                        });
                    }
                }
            })
            .catch((error) => {
                console?.clear()
            });
    }

    getMoreList = () => {
        this.setState({
            loaderForMore: true,
            selectAllMessage: '',
        }, () => {
            if (this.state.active === 'invoiced' || this.state.active === 'shipped' ||  this.state.active === 'pickup') {
                this.setState({
                    pressCount: this.state.pressCount + 1,
                    scrollToIndex: -1
                })
                this.getinvoicelist(true);
            }
            else {
                this.setState({
                    pressCount: this.state.pressCount + 1,
                    scrollToIndex: -1
                })
                this.getRequiredData(true);
            }
        });
    }

    getItemList = () => {
        let filter = [...this.state.filter]
        filter.push({ "field": "itemstatus", "value": "Sold", "op": "=", "join": "AND" })
        filter.push({ field: 'isDeleted', value: 1, op: '!=', join: 'AND' })
        var data = {
            "sort": [{ "field": "id", "direction": "asc" }],
            "filter": filter,
            "page": { "size": this.state.pageCount },
            "field": ["id", "displayimageurl", "title", "itemstatus", "description", "SKU", "category", "isshippable", "istaxable",
                "isfeatured", "itemclosetime", "currentbidprice", "itemsoldprice", "closingorder", "details", "createddate", "isdisplayimage", "salestatus", "thumbnailurl", "soldprice"]
        }
        axios.post(getSellerUrl(`${itemlist}`, {}), JSON.stringify(data), getSellerHeaders())
            .then((response) => {
                if (response.status === 200) {
                    response = response.data.data
                    this.setState({
                        soldList: response.length > 0 ? false : true
                    })

                }
            })
            .catch((error) => {
            });

    };
    getSaleDetail = () => {
        let field = ['id', 'title','saleitemreceiptmethod', 'status', 'invoicegenerated', 'locationid', 'locationtitle', 'endtime', 'timezonename', 'itemcount', 'initiateautodebit', "city", "state", "country", "zipcode", "address1", "address2", "contactname", "contactemail", "contactmobile","pickuptime","islocked","shippingsaint"];
        axios.post(getSellerUrl(`${saledetail}/${this.state.salesId}`), JSON.stringify({ field: field }), getSellerHeaders())
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.data.length == 0) {
                        this.setState({
                            errorpageredirect: true,
                            errorType: "noData"
                        })
                        return;
                    }
                    response = response.data.data[0];
                    const saleitemreceiptmethod = response.saleitemreceiptmethod   ? JSON.parse(response.saleitemreceiptmethod)   : { pickup: false, delivery: false, shipping: false };
                    this.setState({
                        saleShippingSaint: response.shippingsaint,
                        isLocked: response.islocked,
                        invoiceGenerated: response.invoicegenerated > 0 ? true : false,
                        endtime: new Date(moment.tz(response['endtime'], response['timezonename']).local()),
                        status: response.status,
                        Local_saletitle: response.title,
                        locationId: response.locationid,
                        processPaymentDisableButton: response.initiateautodebit === 0 ? false : true,
                        saledetails: response,
                        salePickupDate: response.pickuptime ? new Date(moment(response.pickuptime)) : null,
                        minTimeDate: response.pickuptime ? response.pickuptime : response.endtime,
                        pickupdate: response.pickuptime ? new Date(moment(response.pickuptime)) : null,
                        saleitemreceiptmethod,
                        saleIrmcheck: saleitemreceiptmethod,
                        selectLocationId : response.locationid,

                     })
                }
            },()=>{
            })
            .catch((error) => {
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });

    };
    receiptCheckBox = (event) => {
        const { name, checked } = event.target;
        this.setState((prevState) => ({
            saleitemreceiptmethod: {
                ...prevState.saleitemreceiptmethod,
                [name]: checked
            }
        }), () => {
            const allIrmCheck = Object.values(this.state.saleitemreceiptmethod).every(value => !value);
            this.setState({ bulkValid : allIrmCheck });
        });
    };

    componentDidUpdate() {
        // if((this.state.endtime !== "" && this.state.endtime < new Date()) && (this.state.status.toLowerCase()  !== 'closed') ){
        //     if(!['pending','available','shipped','notsold'].includes(this.state.active) && this.state.itemList.length>0){
        //         this.getItemList();
        //         this.getSaleDetail();
        //     }
        // }
        store.dispatch({ type: 'SET_SIDEBAR', payload: false });
    }



    // Show sidebar when leave sales dashboard
    componentWillUnmount() {
        clearTimeout(this.timer)
        store.dispatch({ type: 'SET_SIDEBAR', payload: true });
        window.removeEventListener('resize', this.getwindowwidth);
        if (this.eventSource) {
            this.eventSource.close();
        }
    }
    getwindowwidth = () => {
        this.setState({
            windowWidth: window.innerWidth
        });
    }
    /* called when note clicked */
    viewNotes = (id) => {
        const data = this.state.itemList.filter(x => x.id === id);
        this.setState({
            ...this.state,
            modal: true,
            itemsDetails: data[0]
        });
        this.id = id;
    }

    /* called when save or note closed */
    hideNotes = () => {
        this.setState({
            ...this.state,
            modal: false
        })
    }

    getLocationSaleList = async () => {
        await axios.all([
            axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
            axios.post(getSellerUrl(salelist), JSON.stringify({ 
                filter: [
                    { field: "status", value: "Closed", op: "!=", join: "AND" }, 
                    { field: 'isDeleted', value: 0, op: '=', join: 'AND' },
                    { field: "locationid", value: this.state.selectLocationId, op: "=", join: "AND" }
                ], 
                field: ['id', 'title', 'status', "locationid"] }), getSellerHeaders())
        ]).then(response => {
            let locationAllList = response[0].data.data
            const filteredSalesList = response[1].data.data.filter(
                (sale) => sale.locationid === this.state.selectLocationId && sale.id != Number(this.state.salesId)
            );
                this.setState({ 
                    locationList: locationAllList,
                    salesList: filteredSalesList,
                    saleAllList: response[1].data.data,
                    showSale: true,
                    bulkValid: true,
                    selectedSale: '',
                    selectLocationId: this.state.selectLocationId
                });
        }).catch(error => {
            this.setState({
                showSale: false
            })
        });
    }

    onChangeStatus = (event) => {
        /* Get sales list */
        if (event.target.value == 'sale') {
            this.getLocationSaleList() 
        }

        this.setState({
            ...this.state,
            changeStatusValue: event.target.value,
            itemTax: '',
            itemBp: '',
            selectedSale: '',
            selectLocationId: this.state.locationId,
            itemistaxable: false,
            bulkValid: event.target.value == 'sale' ||  event.target.value == 'tax' ||  event.target.value == 'buyerspremium'  ? true : false,
            invaliddata: { 
                ...this.state.invaliddata,
                show: false, 
                invaliddata: [] 
            },
            itemStatusToast: { show: false, type: '', message: '' }
        })
    }
    
    inputChange = (event) => {
        if (event.target.name == "itemBp" || event.target.name == "itemTax") {
            event.target.value = event.target.value.replace(/[^0-9.]/g, '')
            if ((event.target.value.includes('.') && event.target.value.split('.')[1].length > 3)) {
                return;
            }
            if (this.timeoutInterval[event.target.name]) {
                clearTimeout(this.timeoutInterval[event.target.name]);
            }
            this.timeoutInterval[event.target.name]  = setTimeout(() => {
                if (event.target.value) {
                     let formattedValue = parseFloat(event.target.value).toFixed(3)
                    this.setState({
                        ...this.state,
                        [event.target.name]:  formattedValue


                    })
                }
            }, 1000);

        }

        this.setState({
            ...this.state,
            [event.target.name]: event.target.name === 'itemistaxable' ? event.target.checked : event.target.value,
            bulkValid: event.target.value ? false : true
        })

    }

    changeItemStatus = () => {

        let checkEndDate = true
        var data = {
            "saleid": this.props?.location?.state?.saletitle?.id ? this.props?.location?.state?.saletitle?.id : this.state.salesId,
            "itemIds": this.state.selectedList,
        }
        if(this.state.changeStatusValue === "itemreceiptmethod"){
            data['itemreceiptmethod'] = this.state.saleitemreceiptmethod
        }
        else if (this.state.changeStatusValue === "status") {
            if (new Date(moment(this.state.endtime)) < new Date()) {
                checkEndDate = false
                this.setState({
                    statusMessage: 'The Sale End Date has already passed. Please adjust the End Date to a future date before changing the item status.'
                })
            } else {
                data['status'] = this.state.active === "pending" ? "Ready" : "Pending"
            }
        }
        else if(this.state.changeStatusValue === "tax"){
            data['tax'] = this.state.itemTax ? this.state.itemTax : 0
        }
        else if(this.state.changeStatusValue === "buyerspremium"){
            data['buyerspremium'] = this.state.itemBp ? this.state.itemBp  : 0
        }
        else if(this.state.changeStatusValue === "istaxable"){
            data['istaxable'] = !this.state.itemistaxable
        }
        else if(this.state.changeStatusValue === "sale"){
            data['updatedsaleid'] = this.state.selectedSale
        }
         if(checkEndDate){
        this.setState({ loading: true })
        axios.put(getSellerUrl(itemBulkUpdate), JSON.stringify({data}), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    const invaliddata = response.data.invaliddata ? response.data.invaliddata : [];
                    this.setState({
                        loading: false,
                        itemStatusToast: { show: invaliddata.length === 0, type: "success", message: 'Saved' },
                        selectedList:   invaliddata?.length !== 0 ?  this.state.selectedList : [],
                        changeStatusValue : '',
                        itemBp: '',
                        itemTax: '',
                        invaliddata: { show: invaliddata.length > 0, invaliddata: invaliddata },
                        checkSelectAll: false,
                    }, () => {
                        if (invaliddata.length === 0) {
                            setTimeout(() => {
                                this.setState({
                                    statusChangeModal: false,
                                    itemStatusToast: { show: false, type: '', message: '' }
                                }, () => this.selectStatus(this.state.active))
                            }, 1000);
                        } else {
                            this.getRequiredData();
                        }
                    });
                }
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    itemStatusToast: { show: true, type: 'danger', message: error?.response?.data?.message }
                })
            })
        }
    }

    /* get all invoice list data */
    getAllInvoice() {
        let filter = []
        filter.push({ field: 'saleid', value: this.props.location?.state?.saletitle?.id ? this.props.location?.state?.saletitle?.id : this.state.salesId, op: '=', join: 'AND' })
        filter.push({ field: 'isDeleted', value: 1, op: '!=', join: 'AND' })
        filter.push({ field: "invoicestatus", value: "Void", op: "!=", join: "AND" })
        let sort = [{ "field": "title", "direction": "asc" }]
        var data = {
            "sort": sort,
            "filter": filter,
        };
        axios.post(getSellerUrl(`${invoiceList}`, {}), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    if (response.data.data.length > 0) {
                        this.setState({
                            printAllInvoiceList: response.data.data.filter(invoice => (invoice.type !== 'RA' && invoice.type !== 'DG'))
                        })
                    }
                }
            })
            .catch(error => {
                this.setState({ loading: false });
            });

    }

    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (this.state.active !== "mir" && this.state.active !== "DG") {
                if (this.state.active === "invoiced" ) {
                    this.enableSearch()
                }
                else if(this.state.active === "shipped" || this.state.active === "pickup" || this.state.active === "delivery") {
                    this.fullFillmentSerach()
                }
                else {
                    this.itemenableSearch()
                }
            }
            else{
                this.searchMir()
            }
        }
    }

    /* Calculate height */
    calculateHeight = () => {
        const tables = document.getElementsByClassName('border');
        const columns = document.getElementsByClassName('status-column');

        const table_height = tables.length > 0 ? tables[0].clientHeight : 0;
        const columns_height = columns.length > 0 ? columns[0].clientHeight : 0;

        const remove = window.innerWidth > 2000 ? 20 : 9;
        const final = ((table_height - (columns_height * 10)) - columns_height) - remove;

        this.setState({
            ...this.state,
            alert_height: final
        });
    }

    getCountForLeft = () => {
        Axios.get(getSellerUrl(`${itemstatusbysale}/${this.state.salesId}`), getSellerHeaders()).then(
            (response) => {
                let data = response.data.data[0];
                if (!response.data.data[0]['Auction'])
                    data['Auction'] = 0;
                if (!response.data.data[0]['Direct buy'])
                    data['Direct buy'] = 0;
                if (!response.data.data[0]['Onsite'])
                    data['Onsite'] = 0;
                let total = data['Auction'] + data['Direct buy'] + data['Onsite'];
                this.setState({
                    ...this.state,
                    allCounts: response.data.data[0],
                    pageLoading: false,
                    totalCount: total,
                    ClosingorderOption: Array.from({ length: total }, (_, i) => (i + 1).toString())
                }, () => {
                    this.calculateHeight();
                });
            }
        ).catch(
            error => {
                this.setState({
                    ...this.state,
                    error: true
                });
            }
        );
    }
    setStartDate = (date) => {
        this.setState({
            ...this.state,
            startDate: date
        });
    }

    setEndDate = (date) => {
        this.setState({
            ...this.state,
            endDate: date
        });
    }

    isShippingDeliveryOption = (name) => {
        return ['pickup', 'shipped', 'delivery'].includes(name);
    }

    selectedOption(name) {
        this.setState({
            ...this.state,
            active: name,
            searchData: true,
            selectedType: "",
            statusChangeModal: false,
            loading: true,
            nextList: null,
            dropdownselect: name,
            fullFillmentFilter: [],
            fullfillmentStatus: false,
            mirFilter: [],
            mirstatus: false,
            shippingDeliveryDropdown: this.isShippingDeliveryOption(name) ? this.state.shippingDeliveryDropdown : false
        }, () =>
            this.resetState())
        if (this.state.isBackHandle) {
            this.setState({
                scrollToIndex: -1
            })
        }
    }

    toggleShippingDeliveryDropdown = () => {
        this.setState({
            shippingDeliveryDropdown: true
        }, () => this.selectedOption('pickup'));
    }

    getShippingDeliveryCount = () => {
        return Number(this.state.allCounts['Pickup'] || 0)
            + Number(this.state.allCounts['Shipped'] || 0)
            + Number(this.state.allCounts['Delivery'] || 0);
    }

    searchInputChange = (event) => {
        let eventValue = event.target.value;
        if (event.target.value === "Unpaid Accepted") {
            this.setState({
                ...this.state,
                invoiceSearch: {
                    ...this.state.invoiceSearch,
                    [event.target.name]: {
                        ...this.state.invoiceSearch[event.target.name],
                        value: "Unpaid"
                    },
                    autoDebitStatus: {
                        ...this.state.invoiceSearch.autoDebitStatus,
                        value: ""
                    },
                    receivedamount: {
                        ...this.state.invoiceSearch.receivedamount,
                        value: 0,
                    },
                    pendingamount: {
                        ...this.state.invoiceSearch.pendingamount,
                        value: 0,
                    },
                    pendingamountreceievd: {
                        ...this.state.invoiceSearch.pendingamountreceievd,
                        value: 0,
                    },
                    bidderacceptance: {
                        ...this.state.invoiceSearch.bidderacceptance,
                        value: ""
                    }

                }
            });
        }
        else if (event.target.value === "autodebitstatus") {
            this.setState({
                ...this.state,
                invoiceSearch: {
                    ...this.state.invoiceSearch,
                    [event.target.name]: {
                        ...this.state.invoiceSearch[event.target.name],
                        value: "Unpaid"
                    },
                    autoDebitStatus: {
                        ...this.state.invoiceSearch.autoDebitStatus,
                        value: "PayPal Restricted"
                    },
                    bidderacceptance: {
                        ...this.state.invoiceSearch.bidderacceptance,
                        value: ""
                    },
                    receivedamount: {
                        ...this.state.invoiceSearch.receivedamount,
                        value: "",
                    },
                    pendingamount: {
                        ...this.state.invoiceSearch.pendingamount,
                        value: "",
                    },
                    pendingamountreceievd: {
                        ...this.state.invoiceSearch.pendingamountreceievd,
                        value: "",
                    },

                }
            });
        }
        else {
            this.setState({
                ...this.state,
                invoiceSearch: {
                    ...this.state.invoiceSearch,
                    [event.target.name]: {
                        ...this.state.invoiceSearch[event.target.name],
                        value: eventValue
                    },
                    bidderacceptance: {
                        ...this.state.invoiceSearch.bidderacceptance,
                        value: ""
                    },
                    autoDebitStatus: {
                        ...this.state.invoiceSearch.autoDebitStatus,
                        value: ""
                    },
                    receivedamount: {
                        ...this.state.invoiceSearch.receivedamount,
                        value: "",
                    },
                    pendingamount: {
                        ...this.state.invoiceSearch.pendingamount,
                        value: "",
                    },
                    pendingamountreceievd: {
                        ...this.state.invoiceSearch.pendingamountreceievd,
                        value: "",
                    },
                }
            });
        }
         if(event.target.name === 'invoicetype'){

            this.setState({
                ...this.state,
                invoiceSearch: {
                    ...this.state.invoiceSearch,
                    type: {
                        ...this.state.invoiceSearch.type,
                        value : eventValue
                    }
                },
            })
        }
        if (this.state.isBackHandle) {
            this.setState({
                scrollToIndex: -1
            })
        }
        if(event.target.name === 'invoicestatus'){
            this.setState({
                setStatusValue: event.target.value,
            })
        }
    }
    onInputChange = (event) => {
        let categoryName = '';
        
        let eventValue = event.target.value;
        this.setState({
            ...this.state,
            categoryMenuName: categoryName ? categoryName : '',
            itemSearch: {
                ...this.state.itemSearch,
                [event.target.name]: {
                    ...this.state.itemSearch[event.target.name],
                    value: eventValue
                }
            }
        }, () => {
            if (event.target.name === "categoryid" && typeof event?.target?.selectedIndex === 'number' && event.target.selectedIndex > -1) {
                categoryName = event.target.options[event.target.selectedIndex]?.parentNode?.label;
                this.setState({
                    ...this.state,
                    categoryMenuName: categoryName ? categoryName : '',
                    itemSearch: {
                        ...this.state.itemSearch,
                        categoryGroup: {
                            ...this.state.itemSearch.categoryGroup,
                            value: eventValue ? categoryName : ''
                        }
                    }
                })
                
            }

        });
        if (this.state.isBackHandle) {
            this.setState({
                scrollToIndex: -1
            })
        }
    }
    resetState() {
        this.setState({
            loaderForMore: false,
            nextList: null,
            loading: true,
            searchData: true,
            invoiceSearch: this.invoiceSearch,
            setStatusValue: ''
        }, () => {
            this.getinvoicelist()
        })
        if (this.state.isBackHandle) {
            this.setState({
                scrollToIndex: -1
            })
        }
    }
    itemresetState() {
        this.setState({
            loaderForMore: false,
            nextList: null,
            loading: true,
            searchData: true,
            itemSearch: this.itemSearch,
            skusortValue: "",
            titlesortValue: 'asc'
        }, () => {
            this.getRequiredData()
        })
        if (this.state.isBackHandle) {
            this.setState({
                scrollToIndex: -1
            })
        }
    }
    itemenableSearch() {
        this.setState({
            loaderForMore: false,
            nextList: null,
            loading: true,
            searchData: true,
        }, () => {
            this.getRequiredData()
        })
        if (this.state.isBackHandle) {
            this.setState({
                scrollToIndex: -1
            })
        }
    }
    fullFillmentSerach = () => {
        let filter = [];
        filter = Object.values(this.state.invoiceSearch).map(item => {
            return item;
        }).filter(item => item.value !== "");
        filter = filter.map(item => { return ({ ...item, value: item.op !== "=" ? `*${item.value}*` : item.value }) })
   
        this.setState({ 
            fullFillmentFilter: filter,
            fullfillmentStatus: true
        });
        
    }
    resetFullFillment = () => {
        let filter = [];
        this.setState({ 
            invoiceSearch: this.invoiceSearch,
            fullFillmentFilter: filter,
            fullfillmentStatus: true
        });
    }
    searchMir() {
        let filter = [];
        filter = Object.values(this.state.itemSearch).map(item => {
            if (item.field === 'title') {
                return { ...item, field: 'itemtitle' };
            }
            return item;
        }).filter(item => item.value !== "");
    
        filter = filter.map(item => { return ({ ...item, value: item.op !== "=" ? `*${item.value}*` : item.value }) })
        
        this.setState({ 
            mirFilter: filter,
            mirstatus: true
        });
    }

    clearMir(){
        let filter = [];
        this.setState({ 
            itemSearch: this.itemSearch,
            mirFilter: filter,
            mirstatus: true
        });

    }
    enableSearch() {
        this.setState({
            loaderForMore: false,
            nextList: null,
            loading: true,
            searchData: true,
        }, () => {
            this.getinvoicelist()
        })
        if (this.state.isBackHandle) {
            this.setState({
                scrollToIndex: -1
            })
        }
    }
    getinvoicelist(append = false) {
        let filter = []
        filter = Object.values(this.state.invoiceSearch).filter(item => (item.value !== "" && item.value !== "addoninvoice"))
        filter = filter.map(item => { return ({ ...item, value: item.op !== "=" ? `*${item.value}*` : item.value }) })
        filter.push({ field: 'saleid', value: this.props.location?.state?.saletitle?.id ? this.props.location?.state?.saletitle?.id : this.state.salesId, op: '=', join: 'AND' })
        filter.push({ field: 'isDeleted', value: 1, op: '!=', join: 'AND' })
        if (this.state.active === 'shipped') {
            filter.push({ field: 'trackshippingid', value: null, op: 'IS NOT', join: 'AND' });
        }
        if (this.state.invoiceSearch.type.value === "Purchase") {
            filter.push({ field: 'invoicevendor', value: 'CTBIDS', op: '=', join: 'AND' });
        }
        if (this.state.invoiceSearch.type.value === "RA") {
            filter.push({ field: 'invoicevendor', value: 'SEEL', op: '=', join: 'AND' });
        }
        if (this.state.invoiceSearch.type.value === "DG") {
            filter.push({ field: 'invoicevendor', value: 'SEEL', op: '=', join: 'AND' });
        }
        if (this.state.invoiceSearch.type.value === "addoninvoice") {
            filter.push({ field: 'masterinvoiceid', value: null, op: 'IS NOT', join: 'AND' });
        }

        let sort = [...this.state.sort]
        var data = {
            "sort": sort,
            "filter": filter,
            "field": ["id", "invoicenumber", "createddate", "details", "invoiceamount", "pendingamount","masterinvoiceid", "emailsent", "invoicestatus", "autoDebitStatus", "createdtype", "bidderacceptance", "buyerid", "taxexcempt","invoiceitemreceiptmethod","additionalnotes","invoiceview", "invoicevendor", "type"],
            "page": append && this.state.nextList ? { "size": this.state.pageCount, next: this.state.nextList } : { "size": this.state.pageCount }
        };
        axios.post(getSellerUrl(`${invoiceList}`, {}), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    response = response.data;
                    // const bidderAcceptance = response.data.filter(elem => elem.bidderacceptance ? elem.bidderacceptance.toLowerCase() === "accepted" : '')
                    // if(bidderAcceptance.length == response.data.length){
                    //     this.setState({
                    //         showProcessPaymentBtn: true
                    //     })
                    // }
                    const buyerIds = response.data.map(x => x.buyerid);
                    const expiryDate = new Date;
                    const validityexpirydate = moment.utc(expiryDate).local().format('YYYY-MM-DD hh:mm:ss');
                    const taxExemptData = {
                        field: ['id', 'locationid', 'buyerid'],
                        filter: [
                            { field: 'buyerid', value: [buyerIds], op: 'IN', join: 'AND' },
                            { field: 'validityexpirydate', value: validityexpirydate, op: '>', join: 'AND' },
                        ]
                    };
                    const tempList = append ? this.state.invoicelist.concat(response.data) : response.data;              
                    const pageNext = response.page && response.page.keyset && response.page.keyset.next ? response.page.keyset.next : null;
                    if (buyerIds.length > 0) {
                        axios.post(getSellerUrl(taxexemptlist), JSON.stringify(taxExemptData), getSellerHeaders()).then(taxexemptlistres => {
                            setTimeout(() => {
                                this.invoiceDataSet(tempList, pageNext, taxexemptlistres.data.data);
                            });
                        }).catch(error => {
                            setTimeout(() => {
                                this.invoiceDataSet(tempList, pageNext, []);
                            });
                        });
                    } else {
                        setTimeout(() => {
                            this.invoiceDataSet(tempList, pageNext, []);
                        });
                    }

                }
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.setState({ loading: false });
            });
    }

    invoiceDataSet = (tempList, pageNext, pendingTaxExemption) => {
        this.setState({
            invoicelist: tempList,
            nextList: pageNext,
            loaderForMore: false,
            loading: false,
            pageCount: 100,
            pendingTaxExemption: pendingTaxExemption
        }, () => {
            // this.getCountForLeft();
            // this.getItemList();
            // this.getSaleDetail();
            if (this.state.isBackHandle) {
                setTimeout(() => {
                    const id = `items_${this.state.scrollToIndex}`
                    const divElement = document.getElementById(id)
                    divElement?.scrollIntoView({ behavior: "auto" });
                });
            }
        });
    }
    selectStatus = (flag, field = "", value = "") => {
        this.setState({
            ...this.state,
            active: flag,
            sort: flag === 'available' ? [{ "field": "closingorder", "direction": "asc" }] : [{ "field": "title", "direction": "asc" }],
            searchData: true,
            selectedType: value,
            statusChangeModal: false,
            loading: true,
            selectedList: [],
            selectedInvoice: [],
            dropdownselect: flag,
            fullFillmentFilter: [],
            mirFilter: [],
            mirstatus: false,
            skusortValue: '',
            titlesortValue: 'asc',
            shippingDeliveryDropdown: false,
            filter: [
                {
                    field: "saleid",
                    value: this.props.match.params.salesId,
                    op: "=",
                    join: "AND"
                },
            ],
            selectAllMessage: '',
            selectedSale: ''
        });
        this.itemresetState()
        if (this.state.isBackHandle) {
            this.setState({
                scrollToIndex: -1
            })
        }
    }
    selectdropStatus = (event) => {
        let optionType = event.target.value
        this.setState({
            dropdownselect: event.target.value
        })
        if (optionType === 'all-items')
            this.selectStatus('all-items');
        else if (optionType === 'mir')
            this.selectStatus('mir');
        else if (optionType === 'DG')
            this.selectStatus('DG');
        else if (optionType === 'auction')
            this.selectStatus('auction', 'itemtypeid', 2)
        else if (optionType === 'direct-buy')
            this.selectStatus('direct-buy', 'itemtypeid', 1)
        else if (optionType === 'onsite-only')
            this.selectStatus('onsite-only', 'itemtypeid', 3)
        else if (optionType === 'bought')
            this.selectStatus('bought', 'itemstatus', 'Sold')
        else if (optionType === 'notsold')
            this.selectStatus('notsold', 'itemstatus', 'Not Sold')
        else if (optionType === 'invoiced')
            this.selectedOption('invoiced')
        else if (optionType === 'shipped')
            this.selectedOption('shipped')
        else if (optionType === 'delivery')
            this.selectedOption('delivery')
        else if (optionType === 'pickup')
            this.selectedOption('pickup')
        else if (optionType === 'available')
            this.selectStatus('available', 'itemstatus', 'Ready')
        else
            this.selectStatus('pending', 'itemstatus', 'Pending')
    }

    itemViewUrl = (id) => `${salesDashboard}/${this.state.salesId}/itemsview/${id}`;

    viewSales = (id, index, event) => {
        event.stopPropagation();
        event.preventDefault();
        this.setState({
            scrollToIndex: index
        }, () => {
            this.props.history.push({ pathname: this.itemViewUrl(id), state: { saletitle: this.props?.location?.state?.saletitle, prevDatatable: this.props?.location?.state?.datatable, state: this.state, itemsId: id } });
        })
    }

    viewInvoiceUrl = (id, type) => {
        if(type == "RA") {
            return `/invoice/ra/view/${id}`;
        } else if(type == "DG") {
            return `/invoice/dg/view/${id}`;
        } else {
            return `/invoice/view/${id}`;
        }
    }

    viewInvoice = (item, index) => {
        this.setState({
            scrollToIndex: index
        }, () => {
            this.props.history.push({
                pathname: this.viewInvoiceUrl(item.id, item.type), state: {
                    prevPath: this.props?.history?.location?.pathname,
                    saletitle: this.props?.location?.state?.saletitle, state: this.state, name: this.state.name,
                    invoiceData: item,
                    invoiceId: item.id
                }
            });
        })
    }
    viewAllInvoice = () => {
        this.setState({
            scrollToIndex: -1
        }, () => {
            this.props.history.push({ pathname: `/invoice/viewall/`, state: { prevPath: this.props?.history?.location?.pathname, invoiceList: this.state.printAllInvoiceList, state: this.state, name: this.state.name, saletitle: this.props?.location?.state?.saletitle } });
        })
    }
    changePickupDateValue = (date) => {
        
        this.setState({
            checkPickupDate: false,
            salePickupDate: date
        })
    }
    changePickupDate = () => {
        this.setState({
            pikcupDateModel: true
        })
    }
    resetPickupDate = () => {
        this.setState({
            salePickupDate : this.state.pickupdate,
            pikcupDateModel: false,
            checkPickupDate: true
        })
    }
    confirmPickupdate = () => {
        const data = {
            "data": {
                "id": this.state.salesId,
                "pickuptime":  moment(new Date(this.state.salePickupDate).setHours(0,0,0)).format("YYYY-MM-DD HH:mm:ss")
            }
        }
        this.setState({
            pickupTimeLoading: true
        })

        axios.put(getSellerUrl(pickuptime), JSON.stringify(data), getSellerHeaders()).then(
            response => {
                this.setState({
                    pickupTimeLoading: false,
                    pickupTimeMsg: response.data.data.message,
                    conditionData: response.data.data,
                    pickupdate: this.state.salePickupDate
                },()=>{
                    setTimeout(() => {
                        this.setState({
                            checkPickupDate: true,
                            pikcupDateModel: false,
                            pickupTimeMsg: ''
                        })
                    }, 3000);
                })
            }
        ).catch(error => {
            this.setState({
                pickupTimeLoading: false,
                pickupTimeErrMsg: { show: true, type: 'danger', message: error?.response?.data['message'] }
            });
        });
    }
    viewSelectedInvoice = (value) => {
        this.setState({
            scrollToIndex: -1,
            selectedPrint: value,
        }, () => {
            this.props.history.push({ pathname: `/invoice/viewall/`, state: { prevPath: this.props?.history?.location?.pathname, invoiceList: this.state.selectedInvoiceList, state: this.state, name: this.state.name, saletitle: this.props?.location?.state?.saletitle } });
        })
    }
 

    editItemUrl = (id) => `/sales/items/edit/${id}`;

    editItem = (item, index, event) => {
        event.stopPropagation();
        event.preventDefault();
        this.setState({
            scrollToIndex: index
        }, () => {
            this.props.history.push({
                pathname: this.editItemUrl(item['id']),
                state: {
                    prevPath: this.props?.history?.location?.pathname,
                    saletitle: this.props?.location?.state?.saletitle,
                    prevDatatable: this.props?.location?.state?.datatable,
                    state: { ...this.state }
                }
            })
        })
    }
    routeToReply = (itemId) => {
        this.props.history.push({ pathname: `/messages/item/reply/${itemId}` });
    };
    setSort = (event) => {
        let sort = [{ "field": "title", "direction": event.target.value }]
        let skusortValue = ""
        const filterValue = {
            "1": { field: "title", value: "asc" },
            "2": { field: "title", value: "desc" },
            "3": { field: "id", value: "asc" },
            "4": { field: "id", value: "desc" },
            "5": { field: "closingorder", value: "asc" },
            "6": { field: "closingorder", value: "desc" },
        };
        const value = filterValue[event.target.value];
        const final = [{ "field": value.field, "direction": value.value }];
        if (event.target.value === "") {
            sort = [{ "field": "SKU", "direction": "asc" }]
            skusortValue = "asc"
        }
        this.setState({
            sort: final,
            titlesortValue: event.target.value,
            skusortValue,
        });
        if (this.state.isBackHandle) {
            this.setState({
                scrollToIndex: -1
            })
        }
    }
    skusetSort = (event) => {
        let skusort = [{ "field": "SKU", "direction": event.target.value }]
        let titlesortValue = ""
        if (event.target.value === "") {
            skusort = [{ "field": "title", "direction": "asc" }]
            titlesortValue = "asc"
        }
        this.setState({
            sort: skusort,
            titlesortValue,
            skusortValue: event.target.value
        });
        if (this.state.isBackHandle) {
            this.setState({
                scrollToIndex: -1
            })
        }
    }



    /* Get count based on field */
    getCount = (flag, value = "") => {
        if (flag === 'all-items') {
            return this.state.tableData.length;
        }
        return this.state.tableData.filter(x => x[flag] === value).length;
    }

    /* Send invoice to buyers */
    sendInvoice = (option = "") => {
        this.setState({
            btnload: true,
            sendDisablebutton: true
        })
        let filter = []
        if (option === "not-sent") {
            filter.push(
                { "field": "emailsent", "value": 0, "op": "=", "join": "AND" },
                { "field": "invoicestatus", "value": "Void", "op": "!=", "join": "AND" }
            )
        } else if (option === "paid-receipt") {
            filter.push({
                "field": "invoicestatus",
                "value": "Paid",
                "op": "=",
                "join": "AND"

            })
        } else if (option === "unpaid-invoice") {
            filter.push({
                "field": "invoicestatus",
                "value": "Unpaid",
                "op": "=",
                "join": "AND"

            })
        }
        var data = {
            "filter": filter,
        };
        Axios.post(getSellerUrl(`${generateEmail}${this.state.salesId}`), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    let msg = 'Email has been sent to buyer successfully';
                    this.setState({
                        salesDashboardStatus: { show: true, type: 'success', message: msg }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                salesDashboardStatus: { show: false, type: '', message: '' },
                                btnload: false,
                                invoiceModal: false,
                                selectedInvoice: [],
                                selectedList: [],
                            });
                        }, 3000)
                    });
                }
                else {
                    this.setState({
                        sendDisablebutton: false
                    })
                }
            })
            .catch(error => {
                this.setState({
                    sendDisablebutton: false,
                    salesDashboardStatus: { show: true, type: 'danger', message: error?.response?.data['message'] },
                    btnload: false,
                    invoiceModal: false
                });
            });
           
        let dataLayerData = {
            'event': 'send_invoice',
            'title': this.props.location?.state?.saletitle?.title ? this.props.location?.state?.saletitle?.title : this.state.Local_saletitle
        }
        addDataLayer(dataLayerData);
    }


    /* Generate Invoice Popup */
    generateInvoiceModal() {
        //navigateTaxExemption           
        let data = {

            "data": {
                "locationid": this.state.locationId
            }

        };
        Axios.get(getSellerUrl(`${checkitemtaxzero + this.state.salesId}`), getSellerHeaders())
            .then(response => {
                if (response.data.data[0].COUNT > 0) {

                    Axios.post(getSellerUrl(`${taxexemptbuyer}${this.state.salesId}`), JSON.stringify(data), getSellerHeaders())
                        .then(response => {
                            if (response.data.status === 'success' && response.data.data.buyerid.length > 0) {

                                this.setState({
                                    TaxExemptModal: true
                                })
                            }
                            else {
                                this.generateInvoice();
                            }
                        })
                        .catch(error => {
                            this.setState({
                                invoiceDisableButton: false,
                                TaxExemptModal: false,
                                salesDashboardStatus: { show: true, type: 'pathname: this.state.prevPathsuccess', message: error?.response?.data['message'] }
                            });
                        });

                }
                else {
                    this.generateInvoice();
                }
            })
    }
    /* Generate Invoice */
    generateInvoice = () => {
        this.setState({
            invoiceDisableButton: true,
            TaxExemptModal: false
        })
        Axios.get(getSellerUrl(`${generateInvoice}/${this.state.salesId}`), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({
                        invoiceGenerated: true,
                        salesDashboardStatus: { show: true, type: 'success', message: 'Successful' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                salesDashboardStatus: { show: false, type: '', message: '' }
                            });
                        }, 3000)
                    });
                }
                else {
                    this.setState({
                        invoiceDisableButton: false
                    })
                }
            })
            .catch(error => {
                this.setState({
                    invoiceDisableButton: false,
                    salesDashboardStatus: { show: true, type: 'pathname: this.state.prevPathsuccess', message: error?.response?.data['message'] }
                });
            })

        let dataLayerData = {
            'event': 'generate_invoice',
            'title': this.props.location?.state?.saletitle?.title ? this.props.location?.state?.saletitle?.title : this.state.Local_saletitle
        }
        addDataLayer(dataLayerData);
    }

    getInvoiceItemList = async(detail, index, invoiceview, invoicetype) => {
        this.setState({
            ViewItemHandleStatus: false,
            itemViewLoader: index,
            invoiceview: invoiceview ? invoiceview : 0,
            viewItemsInvoiceType: invoicetype
        })
        if (this.state.isBackHandle) {
            this.setState({
                scrollToIndex: -1
            })
        }
       
        let field = ["itemid", "url", "thumbnailurl", "saletitle"]
        let itemListData = detail.items
        if(invoicetype != "RA" && invoicetype != "DG"){
            this.setState({
                ViewItemHandleStatus: true
            })
           let  mirdata = {
                "field": ["id", "buyerid", "itemid", "type"],
                "filter": [
                    {
                        "field": "buyerid",
                        "value": detail.buyerid,
                        "op": "=",
                        "join": "AND"
                    },
                    {
                        "field": "itemid",
                        "value":[detail.items.map(item => item.id)],
                        "op": "IN",
                        "join": "AND"
                    },
                    {
                        "field": "rastatus",
                        "value": "OPT_IN",
                        "op": "=",
                        "join": "AND"
                    },
                    {
                        "field": "isfinalquote",
                        "value": 1,
                        "op": "=",
                        "join": "AND"
                    }
                ]
            }
            await axios.post(getSellerUrl(`${quote}`), JSON.stringify(mirdata), getSellerHeaders())
            .then((response) => {
                
                if (response.status === 200) {
                    let mirlistdata = response.data.data
                    itemListData = itemListData.map(item => {
                        let mircheck = mirlistdata.some(data => data.itemid === item.id && data.type == 'RA') ? "YES" : "NO";
                        let dgcheck = mirlistdata.some(data => data.itemid === item.id && data.type == 'DG') ? "YES" : "NO";
                        return {
                            ...item,
                            mircheck: mircheck,
                            dgcheck: dgcheck,
                        };
                    });
                    this.setState({
                        itemListData
                    })
                }
            })
            .catch((error) => {
               
            });
        }
        let filter = [
            {
                "field": "itemid",
                "value": [detail.items.map(item => item.id)],
                "op": "IN",
                "join": "AND"
            },
            {
                "field": "isdisplayimage",
                "value": 1,
                "op": "=",
                "join": "AND"
            }
        ]
        var data = {
            "filter": filter,
            "field": field
        };
        axios.post(getSellerUrl(`${itemimagelist}`, {}), JSON.stringify(data), getSellerHeaders())
            .then((response) => {
                if (response.status === 200) {
                    itemListData = itemListData.map(item => {
                        let itemImgData = response.data.data.filter(data => data.itemid === item.id)
                        if (itemImgData.length > 0 && "url" in itemImgData[0]) {
                            return ({
                                ...item,
                                url: itemImgData[0].url,
                                thumbnailurl: itemImgData[0].thumbnailurl
                            })
                        }
                        else {
                            return item
                        }
                    })
                    this.setState({
                        itemViewModal:  true,
                        itemListData,
                        itemViewLoader: null,
                        applytaxonbp : detail.applytaxonbp,
                    }, () => {
                        if (this.state.isBackHandle) {
                            setTimeout(() => {
                                const id = `items_${this.state.scrollToIndex}`
                                const divElement = document.getElementById(id)
                                divElement?.scrollIntoView({ behavior: "auto" });
                            });
                        }
                    })

                }
                else {
                    this.setState({
                        itemViewModal: invoicetype == "RA" ? false : true,
                        itemListData,
                        itemViewLoader: null
                    })
                }
            })
            .catch((error) => {
                this.setState({
                    itemViewModal:  invoicetype == "RA" ? false : true,
                    itemListData,
                    itemViewLoader: null
                })
            });

    }

    /* Called when delete button confirmed */
    deleteItems = () => {
        this.setState({ deleteLoading: true });
        const itemids = this.state.selectedList

        const data = {
            "items": itemids,
        };
        axios.delete(getSellerUrl(itemdelete), { ...getSellerHeaders(), data: { 'data': data } })
            .then(response => {
                if (response.status === 200) {
                    this.enableSearch();
                    if (response.data.data.items.length > 0) {
                        const responsedata = response.data.data.items;
                        const itemtitles = responsedata.map(x => x.title);
                        this.setState({
                            ...this.state,
                            selectedList: [],
                            deleteLoading: false,
                            itemStatusToast: { show: true, type: 'danger', message: "The following item(s) can't be deleted :" + itemtitles }
                        });
                    }
                    else {
                        this.setState({
                            ...this.state,
                            selectedList: [],
                            deleteLoading: false,
                            itemStatusToast: { show: true, type: 'success', message: "Item(s) have been deleted successfully" }
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    deleteModal: false,
                                    itemStatusToast: { show: false, type: '', message: '' }
                                }, () => this.getRequiredData())
                            }, 3000)
                        });
                    }
                }
            })
            .catch(error => {
                this.setState({
                    ...this.state,
                    deleteLoading: false,
                });
            });
    }

    //status change cancel button action
    statusChangeCancel() {
        this.setState({
            statusChangeModal: false,
            selectedList: [],
            statusType: "",
            statusChangeModal: false,
            selectAllMessage: '',
            changeStatusValue: '',
            statusMessage: '',
            itemStatusToast: { show: false, type: '', message: '' },
            invaliddata: { show: false, invaliddata: [] }

        }, () => this.getRequiredData())
    }
    //status change confirm button action
    confirmStatusChange() {
        var data = {
            "data": {
                "itemIds": this.state.selectedList,
                "saleid": this.state.salesId,
                "status": this.state.statusType
            }
        }
        this.setState({ loading: true })
        axios.put(getSellerUrl(`${itemStatusUpdate}`, {}), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    // toast.success('Successfully item status changed');
                    const invaliddata = response.data.invaliddata ? response.data.invaliddata : [];
                    this.setState({
                        loading: false,
                        itemStatusToast: { show: invaliddata.length === 0, type: "success", message: 'Saved' },
                        invaliddata: { show: invaliddata.length > 0, invaliddata: invaliddata }
                    }, () => {
                        if (invaliddata.length === 0) {
                            setTimeout(() => {
                                this.setState({
                                    statusChangeModal: false,
                                    itemStatusToast: { show: false, type: '', message: '' }
                                }, () => this.selectStatus(this.state.active))
                            }, 1000);
                        } else {
                            this.getRequiredData();
                        }
                    });
                }
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    itemStatusToast: { show: true, type: 'danger', message: error?.response?.data?.message }
                })
            })
    }
    onChangeDropDown(event) {
        let eventValue = event.target.value;
        this.setState({
            statusType: eventValue
        })
    }

    changeAllItemStatus = () => {
        var data = {
            "data": {
                "saleid": this.props?.location?.state?.saletitle?.id ? this.props?.location?.state?.saletitle?.id : this.state.salesId,
                "status": this.state.statusType
            }
        }
        this.setState({ loading: true })
        axios.put(getSellerUrl(itemstatusbulkupdate), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    const invaliddata = response.data.invaliddata ? response.data.invaliddata : [];
                    this.setState({
                        loading: false,
                        itemStatusToast: { show: invaliddata.length === 0, type: "success", message: 'Saved' },
                        selectedList: [],
                        invaliddata: { show: invaliddata.length > 0, invaliddata: invaliddata }
                    }, () => {
                        if (invaliddata.length === 0) {
                            setTimeout(() => {
                                this.setState({
                                    statusChangeModal: false,
                                    itemStatusToast: { show: false, type: '', message: '' }
                                }, () => this.selectStatus(this.state.active))
                            }, 1000);
                        } else {
                            this.getRequiredData();
                        }
                    });
                }
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    itemStatusToast: { show: true, type: 'danger', message: error?.response?.data?.message }
                })
            })
    }
    navigateToList = () => {
        this.props.history.push({ pathname: '/sales', state: this.state.maintain });
    };
    dateFormatCloseTime = (date) => {
        let newdate = moment.tz(date, date).local();
        return `${newdate.format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
    }
    /* Converting value to decimal */
    convertingToDecimal = (value, len = 2) => {
        const check = value ? value : 0;
        return parseFloat(check).toFixed(len);
    }

    scrollToTop = (direction) => {
        const top = direction === 'Up' ? 0 : this.ScrollRef.current.scrollHeight;
        this.ScrollRef.current.scrollTo({ top: top, left: 0, behavior: 'auto' });
    }
    selectAllItem = (event) => {
        let value = event.target.value
        if(event.target.checked){
            let itemlistids = this.state.itemList.map(item => item.id)
            this.setState({
                selectedList : itemlistids,
                selectAllMessage: itemlistids.length == 100  ? "All 100 Items In This Page Is Selected Click More Below To Select More Items" : '',
                checkSelectAll :  true
            })
        }
        else{
            this.setState({
                selectedList : [],
                selectAllMessage : '',
                checkSelectAll : false
            })

        }

    }

    /* Called when scroll content */
    handleScroll = (event) => {
        const scrollTop = event.target.scrollTop;
        if (event.target.scrollTop > 400) {
            this.setState({
                isBackToTop: true,
                scrollTo: scrollTop,
                pageClientWidth: this.ScrollRef.current.clientWidth
            })
        }
        else {
            this.setState({
                scrollTo: scrollTop,
                isBackToTop: false,
                pageClientWidth: this.ScrollRef.current.clientWidth
            })
        }
    };
    // Closing order api changes
    confirmClosingOrder() {
        var data = {
            "data": this.state.SelectedClosingValue
        }
        this.setState({ loading: true })
        axios.put(getSellerUrl(`${itemcloseorder}`, {}), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    axios.get(getSellerUrl(`${itemsync}/${this.state.salesId}`), getSellerHeaders())
                        .then(response => {
                        })
                        .catch(error => {
                        });
                    this.setState({
                        loading: false,
                        ClosingOrderModal: false,
                        SyncButtonEnable: false,
                        itemStatusToast: { show: true, type: 'success', message: 'Saved' }
                    })
                    setTimeout(() => {
                        this.setState({
                            loading: false,
                            ClosingOrderModal: false,
                            itemStatusToast: { show: false, type: '', message: '' }
                        }, () => {
                            this.getRequiredData()
                        })
                    }, 1000);
                }
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    itemStatusToast: { show: true, type: 'danger', message: error?.response?.data?.message }
                })
            })
    }

    // Changes When the item closing order 
    HandleClosingOrder = (event) => {
        let eventValue = event.target.value
        let { ClosingDiasbleValue } = this.state
        let array_data = {
            'id': event.target.name,
            'selectedValue': eventValue,
        }
        ClosingDiasbleValue.push(array_data)
        const ids = ClosingDiasbleValue.map(o => o.id)
        const filtered = ClosingDiasbleValue.filter(({ id }, index) => !ids.includes(id, index + 1))
        const FinalClosingOrder = filtered.sort((a, b) => (a.id > b.id) ? 1 : -1)
        const payload = FinalClosingOrder.map(item => { return { id: item.id, closingorder: item.selectedValue } })
        let value = []
        FinalClosingOrder.map((item, index) => {
            value.push(item.selectedValue)
            this.setState({
                itemcloseorderValue: value,
                SyncButtonEnable: true,
                SelectedClosingValue: payload,
            })
        })
        this.setState({
            ClosingOrderList: FinalClosingOrder
        })
    }

    checkTaxExemption = (buyerid, locationid) => {
        return this.state.pendingTaxExemption.findIndex(x => x.locationid == locationid && x.buyerid == buyerid) > -1;
    }

    taxExemptionUrl = (buyerid) => `/buyer/edit/${buyerid}/taxexemption`;

    navigateToCreate = () => {
        this.props.history.push({
            pathname: `/invoice/create`,
            state: {
                prevPath: this.props?.history?.location?.pathname,
                saletitle: this.props?.location?.state?.saletitle,
                prevDatatable: this.props?.location?.state?.datatable,
                state: this.state,
                name: "Saledashboard"
            }
        })
        // this.props.history.push({ pathname: '/invoice/create',  state: { prevPath: this.props?.history?.location?.pathname, saletitle: this.props?.location?.state?.saletitle, state: this.state, name: this.state.name }});
    }
    /* Navigate to tax exemption page */
    navigateTaxExemption = (buyerid, lastname, firstname,locationid, index) => {
        store.dispatch({ type: 'TAX_EXEMPTION_ALERT', payload: { url: this.state.salesId } });
        let row = { firstname: firstname, lastname: lastname, id: buyerid, locationid: locationid };
        // this.props.history.push(`/buyer/edit/${this.buyerId}/taxexemption`, row);
        this.setState({
            scrollToIndex: index
        }, () => {
            this.props.history.push({ pathname: this.taxExemptionUrl(buyerid), row, state: { prevPath: this.props?.history?.location?.pathname, saletitle: this.props?.location?.state?.saletitle, state: this.state, name: this.state.name, locationid: row.locationid } });
        })
    }

    /** Prevent open or refrsh page when click a tag */
    aTagHandle = (event) => {
        event.preventDefault();
        event.stopPropagation();
    }

    processPayment = (invoiceid, type) => {
        if (type == "processpayment") {
            let invoiceData = this.state.invoicelist;
            let index = invoiceData.findIndex(elem => elem.id == invoiceid)
            invoiceData[index]['isinvoiceprocessing'] = true
            this.setState({
                invoicelist: invoiceData
            }, () => {
                axios.post(getSellerUrl(`${singleProcessPayment}`), { data: { "invoiceid": [invoiceid] } }, getSellerHeaders()).then(response => {
                    if (response.data.status.toLowerCase() === 'success') {
                        invoiceData[index]['isinvoiceprocessing'] = false
                        this.setState({
                            invoicelist: invoiceData
                        })
                    }
                }).catch(error => {
                    invoiceData[index]['isinvoiceprocessing'] = false
                    this.setState({
                        invoicelist: invoiceData
                    })
                });
            })
            
        } else if (type == "processpendinginvoiceamount") {
            let invoiceData = this.state.invoicelist;
            let index = invoiceData.findIndex(elem => elem.id == invoiceid)
            invoiceData[index]['isinvoicependingprocessing'] = true
            this.setState({
                invoicelist: invoiceData
            }, () => {
                axios.post(getSellerUrl(`${invoicePendingProcessPayment}`), { data: { "invoiceid": invoiceid } }, getSellerHeaders()).then(response => {
                    if (response.data.status.toLowerCase() === 'success') {
                        invoiceData[index]['isinvoicependingprocessing'] = false
                        this.setState({
                            invoicelist: invoiceData
                        })
                    }
                }).catch(error => {
                    invoiceData[index]['isinvoicependingprocessing'] = false
                    this.setState({
                        invoicelist: invoiceData
                    })
                });
            })
        } else {
            this.setState({
                processPaymentDisableButton: true
            })
            axios.get(getSellerUrl(`${processPayment}/${this.state.salesId}`), getSellerHeaders())
                .then((response) => {
                    if (response.status === 200) {
                        // this.sseEventListener();
                        this.setState({
                            salesDashboardStatus: { show: true, type: 'success', message: response.data.message }
                        })
                        setTimeout(() => {
                            this.setState({
                                salesDashboardStatus: { show: false, type: '', message: '' },
                            });
                        }, 3000)
                    }
                })
                .catch(error => {
                    this.setState({
                        salesDashboardStatus: { show: true, type: 'pathname: this.state.prevPathsuccess', message: error.response.data['message'] }
                    });
                    setTimeout(() => {
                        this.setState({
                            salesDashboardStatus: { show: false, type: '', message: '' },
                        });
                    }, 3000)
                    this.setState({
                        processPaymentDisableButton: false
                    })
                })

        }
    };
    createInvoice() {
        let saledetails = this.state.saledetails
        // data['title'] = saledetails["title"]
        // data['id'] = saledetails["id"]
        // let name = saledetails["contactname"].split("")
        // data['pickup'] = {

        // }
        this.props.history.push({
            pathname: `/invoice/create`,
            state: {
                prevPath: this.props?.history?.location?.pathname,
                saletitle: saledetails,
                prevDatatable: this.props?.location?.state?.datatable,
                state: this.state,
                name: "Saledashboard",
                data: saledetails,

            }
        })

    }
    

    fullfillmentDetails = (invoiceid, getShippingItems, status) => {
        const data = {
            "field": ["id","itemid","carrier","trackingnumber","itemtitle","notes","saleid","saletitle", "shipmentstatus", "shippingvendor"],
            "filter":[ { field: 'invoiceid', value: Number(invoiceid), op: '=', join: 'AND' } ]
        }
        this.setState({ 
            invstatus: status.toLowerCase() === "paid",
            fullfillmentstatus: true,
            fullfillmentloader: true 
        });
        axios.post(getSellerUrl(fullFillmentList), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                let data = response.data.data
                let itemdata = getShippingItems
                let finaldata = []

                if (response.data.status === 'success') {
                    getShippingItems.forEach(item => {
                        const matchingItem = data.find(dataItem => dataItem.itemid === item.id);
                        
                        if (matchingItem) {
                            finaldata.push(matchingItem);
                        } else {
                            finaldata.push(item);  
                        }
                    });

                    this.setState({  
                        fullFillmentData: this.state.saleShippingSaint ? data : finaldata,
                        fullfillmentLength: response.data?.data,
                        fullfillmentloader: false
                    });
                }
            })
            .catch(error => {
                this.setState({ fullfillmentloader: false });
            })
    }

    getTransactionList = (invoiceid) => {
        const data = {
            filter: [
                { field: 'invoiceid', value: Number(invoiceid), op: '=', join: 'AND' }
            ]
        };
        this.setState({ 
            transactionModalShow: true,
            transactionLoader: true 
        });
        axios.post(getSellerUrl(transactionHistory), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({  
                        transactionData: response.data.data,
                        transactionLoader: false
                    });
                }
            })
            .catch(error => {
                this.setState({ transactionLoader: false });
            })
    }

    getEmailBounceData = (id) => {
    
        this.setState({
            emailBounceModel: true,
            emailbounceLoader: true
        });
        axios.get(getSellerUrl(`${emailBounceView}${id}`), getSellerHeaders())
            .then(response => {
                let data = response.data.data

                this.setState({
                    emailBounceData: data,
                    emailbounceLoader: false
                });

            })
            .catch(error => {
                this.setState({
                    emailbounceLoader: false
                });
            });

    }

    getTransactionMessage = (data) => {
        try {
            if(data) {
                let parsedData = JSON.parse(data) ? JSON.parse(data) : data;
                parsedData = parsedData?.data ? parsedData?.data : parsedData
                let responseCode = parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.processor_response ? 
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.processor_response?.response_code : 
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status ? 
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status : 
                    parsedData?.name ? parsedData?.name : 
                    parsedData?.resource?.status ? parsedData?.resource.status :
                    parsedData?.resource?.processor_response?.response_code

                let message = 
                    responseCode == "0000" && parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status == "COMPLETED" ? "APPROVED" :
                    responseCode == "0000" && parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status == "DECLINED" ? parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status_details?.reason :
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status_details?.reason === "ECHECK" ? responseCodeAndStatus?.["ECHECK"] :
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status_details?.reason === "PENDING_REVIEW" ? responseCodeAndStatus?.["PENDING"] :
                    responseCode == "PENDING" ?  parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status_details?.reason : 
                    parsedData?.name == 'UNPROCESSABLE_ENTITY' ? parsedData?.details[0]?.description : 
                    // (parsedData == "INTERNAL_SERVER_ERROR" || parsedData.name == "INTERNAL_SERVER_ERROR") ? 'PayPal Payment Gateway currently unavailable: This payment could not be processed at this time. Please try again later.' : 
                    (parsedData?.code === 500 ||  parsedData?.name == 'GATEWAY_TIMEOUT' || parsedData?.code === 502 || parsedData == "INTERNAL_SERVER_ERROR" || parsedData?.name == "INTERNAL_SERVER_ERROR"|| parsedData == "error code: 502" || parsedData == "error code: 500") ? 
                    responseCodeAndStatus?.["500"] :
                    parsedData?.status == "PAYER_ACTION_REQUIRED" ? "Payer Action Required - Call Customer to discuss required actions from financial institution." :
                    responseCode == "PPAB" ? "ACCOUNT_BLOCKED_BY_ISSUER" :
                    responseCode == "DECLINED" ? responseCodeAndStatus?.['CTBHD'] : 
                    responseCode == "COMPLETED" ? "Payment approved and completed" : 
                    parsedData?.message ? parsedData.message : responseCode ? `${responseCode} - ${responseCodeAndStatus?.[responseCode]}` : responseCodeAndStatus?.['CTBHD'];
                
                return message ? message : "---"
            } 
        } catch (err) {
            //handle err
        }
        return responseCodeAndStatus?.['CTBHD'];
    }

    /* Called when sales select */
    selectSale = (event) => {
        this.setState({
             selectedSale: event.target.value,
             bulkValid :  false
        });
    }
    selectLocation = (event) => {
        const selectedLocationId = parseInt(event.target.value); 

        // const filteredSalesList = this.state.saleAllList.filter(
        //     sale => sale.locationid === selectedLocationId && sale.id !== Number(this.state.salesId)
        // );

        this.setState({
            selectLocationId: selectedLocationId, 
            // salesList: filteredSalesList,
            selectedSale: '',
            bulkValid : true
        }, () => {
            this.getLocationSaleList();
        });
    };
    

    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div className="main-div sales-dashboard" style={{ overflowX: this.state.windowWidth > 425 ? "auto" : "hidden", overflowY: "auto" }} ref={this.ScrollRef} onScroll={this.handleScroll}>
                {
                    this.state.pageLoading && !this.state.error ?
                        <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                        </div> : !this.state.pageLoading && !this.state.error ? <div className="item-responsive">
                            <div className="d-flex flex-column mt-2">
                                <div className="d-flex flex-row align-items-center" style={{ minHeight: '40px' }}>
                                    <div className="d-flex flex-row align-items-center justify-content-center border-right border-outline px-2 h-100">
                                        <span className="clickable" onClick={this.navigateToList}>
                                            <i className="fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i>
                                            <span className="ml-2">Back</span>
                                        </span>
                                    </div>
                                    <span className="mx-2">{this.props.location?.state?.saletitle?.title ? this.props.location?.state?.saletitle?.title : this.state.Local_saletitle}</span>
                                    <span className="content-spacer"></span>
                                    <div className="right-side-content mb-2">
                                        {/* {window.screen.width < 800 && <span className="mx-2">{this.props.location.state.saletitle.title}</span>} */}

                                        {/* {
                                            this.state.salesDashboardStatus.show ?
                                                <ToasterMessage type={this.state.salesDashboardStatus.type} message={this.state.salesDashboardStatus.message} className="alert-handle"></ToasterMessage>
                                                : null
                                        } */}
                                        {this.state.windowWidth > 425 &&
                                            <div className="d-flex align-items-center">
                                                {this.state.active.includes('available') || this.state.active.includes('pending') ?
                                                    <div className="d-flex align-items-center">
                                                        {this.state.active.includes('pending') ? <Button style={{ fontSize: 12, width: "160px", backgroundColor: '#A50050' }} onClick={() => this.setState({ deleteModal: true })} disabled={this.state.selectedList.length === 0}>Delete Item(s) Selected</Button> : " "}
                                                        <Button style={{ marginLeft: "2%", fontSize: 12, width: "160px", backgroundColor: '#00263E' }}
                                                            disabled={(this.state.status.toLowerCase() === 'closed' ) || this.state.selectedList.length === 0}
                                                            onClick={() => {
                                                                this.setState({
                                                                    statusChangeModal: true,
                                                                    selectedButton: "all",
                                                                    statusType: this.state.selectedType === 'Ready' ? 'Pending' : 'Ready'
                                                                })
                                                            }}>Item Bulk Update</Button>
                                                        {/* <Button style={{ marginLeft: "2%", width: "160px", fontSize: 12,backgroundColor: '#00263E' }}
                                                            disabled={this.state.selectedType === "" || this.state.selectedList.length === 0 || this.state.status.toLowerCase() === 'closed' || !((this.state.active.includes('available') && this.state.allCounts['Ready'] && this.state.allCounts['Ready'] > 0) || (this.state.active.includes('pending') && this.state.allCounts['Pending'] && this.state.allCounts['Pending'] > 0))}
                                                            onClick={() => {
                                                                this.setState({
                                                                    statusChangeModal: true,
                                                                    selectedButton: "individual",
                                                                    statusType: this.state.selectedType === 'Ready' ? 'Pending' : 'Ready'
                                                                })
                                                            }} >Item Status Change</Button> */}
                                                    </div>
                                                    : ''}
                        
                                                <Button onClick={() => this.changePickupDate()} className="save-button ml-1" disabled={this.state.isLocked}>Change Pickup Date</Button>
                                                {this.state.active === 'invoiced' && this.state.invoiceGenerated && (this.state.status.toLowerCase() === 'closed') && <Button className="save-button ml-1" onClick={() => this.createInvoice()}>+ Create</Button>}
                                                {this.state.active === 'invoiced' ? <Button className="save-button print-btn ml-1" onClick={() => this.viewAllInvoice()} disabled={this.state.printAllInvoiceList.length < 1 || this.state.selectedInvoice.length >= 1 }>Print All</Button> : " "}
                                                {this.state.active === 'invoiced' ? <Button  style={{ backgroundColor: '#D86385' }} className="save-button print-btn ml-1" onClick={() => this.viewSelectedInvoice(true)} disabled={this.state.selectedInvoiceList < 1 }>Print Selected</Button> : " "}
                                                {this.state.active === 'invoiced' ? <Button onClick={() => this.setState({ invoiceModal: true })} style={{ backgroundColor: "#1d8296" }} className="ml-1" >Email Invoices</Button> : ""}
                                                {this.state.active.includes('invoiced') ? <Button className="generate-invoice"  disabled={this.state.processPaymentDisableButton || !this.state.invoiceGenerated} onClick={() => this.processPayment()}>
                                                    Process payment</Button> : ''}

                                                <Button className="generate-invoice" onClick={() => this.generateInvoiceModal()}
                                                    // disabled={(!this.props.location.state.saletitle.invoicegenerated && !this.state.invoiceGenerated && this.props.location.state.saletitle.status.toLowerCase() === 'closed') || !this.state.salesDashboardStatus.show ? false : true}
                                                    disabled={this.state.invoiceDisableButton || ( this.state.status.toLowerCase() === 'closed' ? !(this.state.soldList || this.state.allCounts['Sold']) || this.state.invoiceGenerated : true)}
                                                >
                                                    {this.state.invoiceGenerated ? 'Invoice Generated' : 'Generate Invoice'} </Button>
                                                {this.state.active !== 'invoiced' && this.state.status.toLowerCase() !== 'closed' &&
                                                    // <Link to={{
                                                    //     pathname: '/sales/item/create',
                                                    // }}>
                                                    <Button disabled={this.props.location.state !== undefined && this.props?.location?.state?.isClosed} className="save-button ml-1" onClick={() => this.props.history.push({ pathname: '/sales/item/create', state: { prevPath: this.props?.history?.location?.pathname, saletitle: this.state.Local_saletitle, prevDatatable: this.props?.location?.state?.datatable, state: this.state } })} >+ Item</Button>
                                                    // </Link>
                                                }
                                            </div>} </div>
                                </div>

                                {this.state.windowWidth < 425 ?
                                    <div style={{ paddingLeft: "14px", paddingTop: "10px" }}>
                                        <div className="buttons" style={{}}>

                                            {
                                                this.state.salesDashboardStatus.show ?
                                                    <ToasterMessage type={this.state.salesDashboardStatus.type} message={this.state.salesDashboardStatus.message} className="alert-handle"></ToasterMessage>
                                                    : null
                                            }
                                            {this.state.active.includes('available') || this.state.active.includes('pending') ?
                                                <div className="" style={{ width: this.state.windowWidth - 35 }}>
                                                    <div style={{ marginBottom: "3%" }}>
                                                        <Button style={{backgroundColor:'#00263E', fontSize: 12, width: '100%' }}
                                                            disabled={(this.state.status.toLowerCase() === 'closed' ) || this.state.selectedList.length === 0}
                                                            onClick={() => {
                                                                this.setState({
                                                                    statusChangeModal: true,
                                                                    selectedButton: "all",
                                                                    statusType: this.state.selectedType === 'Ready' ? 'Pending' : 'Ready'
                                                                })
                                                            }}>Item Bulk Update</Button>
                                                    </div>
                                                    <div style={{ marginBottom: "3%", float: "left" }}>
                                                        {/* <Button style={{backgroundColor:'#00263E', fontSize: 12, width: ((this.state.windowWidth - 35) / 2) - 7 }}
                                                            disabled={this.state.selectedType === "" || this.state.selectedList.length === 0 || this.state.status.toLowerCase() === 'closed' || !((this.state.active.includes('available') && this.state.allCounts['Ready'] && this.state.allCounts['Ready'] > 0) || (this.state.active.includes('pending') && this.state.allCounts['Pending'] && this.state.allCounts['Pending'] > 0))}
                                                            onClick={() => {
                                                                this.setState({
                                                                    statusChangeModal: true,
                                                                    selectedButton: "individual",
                                                                    statusType: this.state.selectedType === 'Ready' ? 'Pending' : 'Ready'
                                                                })
                                                            }} >Item Status Change</Button> */}
                                                    </div></div>
                                                : ''}

                                            {this.state.active.includes('invoiced') ?
                                                <div className="" style={{ width: this.state.windowWidth - 35 }}>
                                                    <div style={{ marginBottom: "3%", float: "right", }}>
                                                        <Button style={{ fontSize: 12, width: ((this.state.windowWidth - 35) / 2) - 7 }} className="save-button" onClick={() => this.viewAllInvoice()} disabled={this.state.printAllInvoiceList.length < 1}>Print All</Button>
                                                    </div>
                                                    <div style={{ marginBottom: "3%", float: "left" }}>
                                                        <Button style={{ fontSize: 12, width: ((this.state.windowWidth - 35) / 2) - 7 }} className="save-button" onClick={() => this.viewSelectedInvoice()} disabled={this.state.selectedInvoiceList < 1}>Print Selected</Button>
                                                    </div>
                                                </div>
                                                : ''}
                                            <div style={{ width: this.state.windowWidth - 35 }}>
                                                <div className="generate-invoice" style={{ marginBottom: "3%", float: "right" }}>
                                                    <Button className="mobile-invoice" style={{ width: ((this.state.windowWidth - 35) / 2) - 7 }} onClick={() => this.generateInvoiceModal()}
                                                        disabled={this.state.invoiceDisableButton || (this.state.status.toLowerCase() === 'closed' ? !(this.state.soldList || this.state.allCounts['Sold']) || this.state.invoiceGenerated : true)} >
                                                        {this.state.invoiceGenerated ? 'Invoice Generated' : 'Generate Invoice'} </Button>
                                                </div>
                                                {this.state.active !== 'invoiced' && this.state.status.toLowerCase() !== 'closed' ? 
                                                    <div style={{ marginBottom: "3%", float: "left" }}><Button style={{ fontSize: 14, backgroundColor: "#A50050", width: ((this.state.windowWidth - 35) / 2) - 7 }}
                                                        disabled={this.props.location.state !== undefined && this.props.location.state.isClosed}
                                                        className="" onClick={() => this.props.history.push({ pathname: '/sales/item/create', state: { prevPath: this?.props?.history?.location?.pathname, saletitle: this.state.Local_saletitle, prevDatatable: this.props?.location?.state?.datatable, state: this.state } })} >
                                                        + Item</Button></div> : 
                                                    <div style={{ marginBottom: "3%" }}>
                                                        <Button className="mobile-invoice" style={{ width: ((this.state.windowWidth - 35) / 2) - 7 }} disabled={this.state.processPaymentDisableButton || !this.state.invoiceGenerated} onClick={() => this.processPayment()}>
                                                            Process payment</Button></div>

                                                }</div>
                                            {this.state.active === 'invoiced' ?
                                                <div style={{ marginBottom: "1%", }}>
                                                    <Button onClick={() => this.setState({ invoiceModal: true })}
                                                        style={{ backgroundColor: "#1D8296", width: this.state.windowWidth - 35 }} className="" >Email Invoices</Button> </div>
                                                :
                                                <div style={{ marginBottom: "1%", }}> <Button disabled={this.state.sendDisablebutton || (!this.state.invoiceGenerated)} onClick={() => this.sendInvoice()}
                                                    style={{ backgroundColor: "#1D8296", width: this.state.windowWidth - 35 }} className="" >Send/Resend Unpaid Invoice to Buyers</Button></div>
                                            }
                                            {
                                                <div style={{ marginBottom: "1%", }}> <Button onClick={() => this.changePickupDate()} 
                                                    style={{ backgroundColor: "#1D8296", width: this.state.windowWidth - 35 }} className="save-button ml-1" >Change Pickup Date</Button></div>
                                            }

                                        </div> </div> : ''}

                                <div className="border-bottom border-outline" style={{ display: 'flex', justifyContent: 'center', color: 'red' }}>
                                    {
                                        this.state.salesDashboardStatus.show ?
                                            <ToasterMessage type={this.state.salesDashboardStatus.type} message={this.state.salesDashboardStatus.message} className="alert-handle"></ToasterMessage>
                                            : null
                                    }
                                </div>
                            </div>
                            <div className="d-flex flex-row bd-highlight mb-3">
                                <div className="d-flex flex-column">
                                    <div className="d-flex flex-column status-row mb-3">
                                        {this.state.windowWidth > 425 ?
                                            <div className="sale-dashboard-items">
                                                <div className={`status-column ${this.state.active === 'all-items' ? 'active' : ''}`} onClick={() => this.selectStatus('all-items')}>
                                                    <div className="word">All items</div>
                                                    <div className="count">{this.state.totalCount}</div>
                                                </div>
                                                <div className={`status-column ${this.state.active === 'auction' ? 'active' : ''}`} onClick={() => this.selectStatus('auction', 'itemtypeid', 2)}>
                                                    <div className="word">Auction</div>
                                                    <div className="count">{this.state.allCounts['Auction'] ? this.state.allCounts['Auction'] : 0}</div>
                                                </div>
                                                <div className={`status-column ${this.state.active === 'direct-buy' ? 'active' : ''}`} onClick={() => this.selectStatus('direct-buy', 'itemtypeid', 1)}>
                                                    <div className="word">Direct Buy</div>
                                                    <div className="count">{this.state.allCounts['Direct buy'] ? this.state.allCounts['Direct buy'] : 0}</div>
                                                </div>
                                                <div className={`status-column ${this.state.active === 'onsite-only' ? 'active' : ''}`} onClick={() => this.selectStatus('onsite-only', 'itemtypeid', 3)}>
                                                    <div className="word">Onsite Only</div>
                                                    <div className="count">{this.state.allCounts['Onsite'] ? this.state.allCounts['Onsite'] : 0}</div>
                                                </div>
                                                <div className={`status-column ${this.state.active === 'bought' ? 'active' : ''}`} onClick={() => this.selectStatus('bought', 'itemstatus', 'Sold')}>
                                                    <div className="word">Sold</div>
                                                    <div className="count">{this.state.allCounts['Sold'] ? this.state.allCounts['Sold'] : 0}</div>
                                                </div>
                                                <div className={`status-column ${this.state.active === 'notsold' ? 'active' : ''}`} onClick={() => this.selectStatus('notsold', 'itemstatus', 'Not Sold')}>
                                                    <div className="word">Not Sold</div>
                                                    <div className="count">{this.state.allCounts['Not Sold'] ? this.state.allCounts['Not Sold'] : 0}</div>
                                                </div>
                                                <div className={`status-column ${this.state.active === 'invoiced' ? 'active' : ''}`} onClick={() => this.selectedOption('invoiced')}>
                                                    <div className="word">Invoiced</div>
                                                    <div className="count">{this.state.allCounts['Invoiced'] ? this.state.allCounts['Invoiced'] : 0}</div>
                                                </div>
                                                <div className={`shipping-delivery-menu ${['pickup', 'shipped', 'delivery'].includes(this.state.active) ? 'active' : ''}`}>
                                                    <div className="status-column shipping-delivery-toggle" onClick={() => this.toggleShippingDeliveryDropdown()}>
                                                        <div className="word">Shipping &amp; Pickup</div>
                                                        <i className={`fa ${this.state.shippingDeliveryDropdown ? 'fa-chevron-down' : 'fa-chevron-right'} shipping-delivery-arrow`}></i>
                                                        <div className="count">{this.state.shippedTotalCount ? this.state.shippedTotalCount : this.getShippingDeliveryCount()}</div>
                                                    </div>
                                                    {this.state.shippingDeliveryDropdown ?
                                                        <div className="shipping-delivery-options">
                                                            <div className={`shipping-delivery-option ${this.state.active === 'pickup' ? 'active' : ''}`} onClick={() => this.selectedOption('pickup')}>
                                                                <div className="word">&gt; Pickup</div>
                                                                <div className="count">{this.state.allCounts['Pickup'] ? this.state.allCounts['Pickup'] : 0}</div>
                                                            </div>
                                                            <div className={`shipping-delivery-option ${this.state.active === 'shipped' ? 'active' : ''}`} onClick={() => this.selectedOption('shipped')}>
                                                                <div className="word">&gt; Shipping</div>
                                                                <div className="count">{this.state.allCounts['Shipped'] ? this.state.allCounts['Shipped'] : 0}</div>
                                                            </div>
                                                            <div className={`shipping-delivery-option ${this.state.active === 'delivery' ? 'active' : ''}`} onClick={() => this.selectedOption('delivery')}>
                                                                <div className="word">&gt; Delivery</div>
                                                                <div className="count">{this.state.allCounts['Delivery'] ? this.state.allCounts['Delivery'] : 0}</div>
                                                            </div>
                                                        </div>
                                                        : ''
                                                    }
                                                </div>

                                                <div className={`status-column ${this.state.active === 'available' ? 'active' : ''}`} onClick={() => this.selectStatus('available', 'itemstatus', 'Ready')}>
                                                    <div className="word">Ready</div>
                                                    <div className="count">{this.state.allCounts['Ready'] ? this.state.allCounts['Ready'] : 0}</div>
                                                </div>
                          
                                                {<div className={`status-column ${this.state.active === 'pending' ? 'active' : ''}`} onClick={() => this.selectStatus('pending', 'itemstatus', 'Pending')}>
                                                    <div className="word">Pending</div>
                                                    <div className="count">{this.state.allCounts['Pending'] ? this.state.allCounts['Pending'] : 0}</div>
                                                </div>}
                                                {<div className={`status-column ${this.state.active === 'mir' ? 'active' : ''}`} onClick={() => this.selectStatus('mir')}>
                                                <div className="word">Make It Returnable Status</div>
                                                <div className="count">{this.state.allCounts['RA'] ? this.state.allCounts['RA'] : 0}</div>
                                            </div>}
                                            {<div className={`status-column ${this.state.active === 'DG' ? 'active' : ''}`} onClick={() => this.selectStatus('DG')} >
                                                <div className="word">Delivery Guarantee Status</div>
                                                <div className="count" style={{ height: "20px" }}>{this.state.allCounts['DG'] ? this.state.allCounts['DG'] : 0}</div>
                                            </div>}
                                                {/* {<div className={`status-column alert-column ${this.state.active === 'alerts' ? 'active' : ''}`} onClick={() => this.selectStatus('alerts', 'itemstatus', 'Alerts')} style={{ height: `${this.state.alert_height}px` }}>
                                                <div className="word">Alerts</div>
                                                <div className="count alerts">{this.getCount('itemstatus', 'Alerts')}</div>
                                            </div>} */}
                                            </div> : ""
                                        }
                                    </div>
                                </div>
                                <div className="invoiced" style={{ width: this.state.windowWidth < 425 ? this.state.windowWidth - 30 :  (this.state.active === 'mir' || this.state.active === 'DG')&&  this.state.windowWidth < 1700 ? "80%" : "100%", marginLeft: this.state.windowWidth < 425 ? "1%" : "0%", marginBottom: "5%" }}>


                                    {
                                        this.state.active === 'invoiced' || this.state.active === 'shipped' || this.state.active === 'pickup' || this.state.active === 'delivery' ?
                                            <div className="invoice-search" style={{ marginTop: 0 }}>
                                                <div className="invoice-list-search">
                                                    <Form className="invoice-list-font">
                                                        <div className="invoice-search-container">
                                                            <Row>
                                                                {this.state.windowWidth < 425 ?
                                                                    <Col className={"px-1"}>

                                                                        <Form.Group className="remove-bottom" controlId="formGridState">
                                                                            <Form.Control onChange={(event) => this.selectdropStatus(event)} as="select" className="dropdowncolor" value={this.state.dropdownselect}>
                                                                                <option value='all-items' className="dropdownoptioncolor"> All items ({this.state.totalCount}) </option>
                                                                                <option value='auction' className="dropdownoptioncolor"> Auction  ({this.state.allCounts['Auction'] ? this.state.allCounts['Auction'] : 0})</option>
                                                                                <option value='direct-buy' className="dropdownoptioncolor"> Direct Buy ({this.state.allCounts['Direct buy'] ? this.state.allCounts['Direct buy'] : 0}) </option>
                                                                                <option value='onsite-only' className="dropdownoptioncolor"> Onsite Only ({this.state.allCounts['Onsite'] ? this.state.allCounts['Onsite'] : 0}) </option>
                                                                                <option value='bought' className="dropdownoptioncolor"> Sold ({this.state.allCounts['Sold'] ? this.state.allCounts['Sold'] : 0}) </option>
                                                                                <option value='notsold' className="dropdownoptioncolor"> Not Sold ({this.state.allCounts['Not Sold'] ? this.state.allCounts['Not Sold'] : 0}) </option>
                                                                                <option value='invoiced' className="dropdownoptioncolor"> Invoiced ({this.state.allCounts['Invoiced'] ? this.state.allCounts['Invoiced'] : 0}) </option>
                                                                                <option value='pickup' className="dropdownoptioncolor"> Pickup ({this.state.allCounts['Pickup'] ? this.state.allCounts['Pickup'] : 0}) </option>
                                                                                <option value='shipped' className="dropdownoptioncolor"> Shipped ({this.state.allCounts['Shipped'] ? this.state.allCounts['Shipped'] : 0}) </option>
                                                                                <option value='delivery' className="dropdownoptioncolor"> Delivery ({this.state.allCounts['Delivery'] ? this.state.allCounts['Delivery'] : 0}) </option>
                                                                                <option value='available' className="dropdownoptioncolor"> Ready ({this.state.allCounts['Ready'] ? this.state.allCounts['Ready'] : 0}) </option>
                                                                                <option value='pending' className="dropdownoptioncolor"> Pending ({this.state.allCounts['Pending'] ? this.state.allCounts['Pending'] : 0}) </option>
                                                                                <option value='mir' className="dropdownoptioncolor"> Make It Returnable </option>

                                                                            </Form.Control>
                                                                        </Form.Group>
                                                                    </Col> : ""
                                                                }
                                                                <Col className={"px-1"}>
                                                                    <label>Invoice No</label>
                                                                    <Form.Control type="text" name="invoicenumber" onKeyDown={this._handleKeyDown} value={this.state.invoiceSearch.invoicenumber.value} onChange={(event) => this.searchInputChange(event)} />
                                                                </Col>
                                                                {this.state.active === 'pickup' && <> <Col className={"px-1"}>
                                                                    <label>Item Title</label>
                                                                    <Form.Control type="text" name="itemtitle" onKeyDown={this._handleKeyDown} value={this.state.invoiceSearch.itemtitle.value} onChange={(event) => this.searchInputChange(event)} />
                                                                </Col> </>}
                                                                
                                                                {this.state.active != 'shipped' && this.state.active != 'pickup' && this.state.active != 'delivery' ? <> <Col className={"px-1"}>
                                                                    <label>Item Title</label>
                                                                    <Form.Control type="text" name="itemtitle" onKeyDown={this._handleKeyDown} value={this.state.invoiceSearch.itemtitle.value} onChange={(event) => this.searchInputChange(event)} />
                                                                </Col>
                                                                <Col className={"px-1"}>
                                                                    <label>Email Sent</label>
                                                                    <Form.Control as="select" name="emailsent" onKeyDown={this._handleKeyDown} value={this.state.invoiceSearch.emailsent.value} onChange={(event) => { this.searchInputChange(event) }} >
                                                                        <option value='' >All</option>
                                                                        <option value={1}>Yes</option>
                                                                        <option value={0}>No</option>
                                                                    </Form.Control>
                                                                </Col>
                                                                <Col className={"px-1"}>
                                                                    <label>Status</label>
                                                                    <Form.Control as="select" name="invoicestatus" onKeyDown={this._handleKeyDown} value={this.state.setStatusValue} onChange={(event) => { this.searchInputChange(event) }}>
                                                                        <option value='' >All</option>
                                                                        <option value="Paid">Paid</option>
                                                                        <option value="autodebitstatus">PayPal Restricted</option>
                                                                        <option value="Unpaid Accepted">Unpaid-Partial Payment</option>
                                                                        <option value="Unpaid">Unpaid-No Payment</option>
                                                                        <option value="Void">Void</option>
                                                                    </Form.Control>
                                                                </Col> </> : '' }
                                                                {this.state.active !== 'pickup' && <Col className={"px-1"}>
                                                                    <label>Buyer Email Address</label>
                                                                    <Form.Control type="text" name="buyeremail" onKeyDown={this._handleKeyDown} value={this.state.invoiceSearch.buyeremail.value} onChange={(event) => this.searchInputChange(event)} />
                                                                </Col>}
                                                                {
                                                                    this.state.active === 'shipped' || this.state.active === 'pickup' || this.state.active === 'delivery' ? <><Col className={"buttonClass px-1"} style={{ marginTop: '20px' }}>
                                                                    <Button className="clear-button" disabled={this.state.issearch === false} onClick={() => this.resetFullFillment()}>Clear All</Button>
                                                                    <Button variant="seller-search" disabled={this.state.issearch === false} onClick={() => this.fullFillmentSerach()}>Search</Button>
                                                            
                                                            </Col></> : ''
                                                                }
                                                            </Row>
                                                           { this.state.active !== 'shipped' && this.state.active !== 'pickup' && this.state.active !== 'delivery' ? <Row  >
                                                                <Col className={"px-1"}>
                                                                    <label>Buyer First Name</label>
                                                                    <Form.Control type="text" name="firstname" onKeyDown={this._handleKeyDown} value={this.state.invoiceSearch.firstname.value} onChange={(event) => this.searchInputChange(event)} />
                                                                </Col>
                                                                <Col className={"px-1"}>
                                                                    <label>Buyer Last Name</label>
                                                                    <Form.Control type="text" name="lastname" onKeyDown={this._handleKeyDown} value={this.state.invoiceSearch.lastname.value} onChange={(event) => this.searchInputChange(event)} />
                                                                </Col>
                                                                <Col className={"px-1"}>
                                                                    <label>IRM</label>
                                                                    <Form.Control as="select" name="irm" onKeyDown={this._handleKeyDown} value={this.state.invoiceSearch.irm.value} onChange={(event) => { this.searchInputChange(event) }} >
                                                                        <option value='' >All</option>
                                                                        <option value={'shipping'}>Shipping</option>
                                                                        <option value={'pickup'}>Pickup</option>
                                                                        <option value={'delivery'}>Delivery</option>
                                                                    </Form.Control>
                                                                </Col>
                                                                {/* <Col className={"px-1"}>
                                                                    <label>Make It Returnable Status <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Make It Returnable Opted In'}</Tooltip>}>
                                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px", color: "black" }}></i>
                                                                    </OverlayTrigger></label>
                                                                    <Form.Control as="select" name="mirstatus" onKeyDown={this._handleKeyDown} value={this.state.invoiceSearch.mirstatus.value} onChange={(event) => { this.searchInputChange(event) }} >
                                                                        <option value='' >All</option>
                                                                        <option value={1}>Yes</option>
                                                                        <option value={0}>No</option>
                                                                    </Form.Control>

                                                                </Col> */}
                                                                
                                                                <Col className={"px-1"} >
                                                                        <label>Invoice Type</label>
                                                                        <Form.Control as="select" name="invoicetype" onKeyDown={this._handleKeyDown} value={this.state.invoiceSearch.type.value} onChange={(event) => { this.searchInputChange(event) }} >
                                                                            <option value='' >All</option>
                                                                            <option value={'Purchase'}>Item Invoice</option>
                                                                            <option value={'RA'}>Make It Returnable Invoice</option>
                                                                            <option value={'DG'}>Delivery Guarantee Invoice</option>
                                                                            <option value={'addoninvoice'}>Add On Invoice</option>
                                                                        </Form.Control>
                                                                </Col>
                                                                <Col></Col>
                                                            </Row> : ''}
                                                           { this.state.active !== 'shipped' && this.state.active !== 'pickup' && this.state.active !== 'delivery' ? <Row>
                                                                <Col></Col>
                                                                <Col></Col>
                                                                <Col></Col>
                                                                <Col></Col>
                                                                <Col></Col>
                                                                <Col className={"buttonClass px-1"} >
                                                                        <Button className="clear-button" disabled={this.state.issearch === false} onClick={() => this.resetState()}>Clear All</Button>
                                                                        <Button variant="seller-search" disabled={this.state.issearch === false} onClick={() => this.enableSearch()}>Search</Button>
                                                                
                                                                </Col> 
                                                            </Row>: ''}
                                                        </div>
                                                    </Form>
                                                </div>
                                            </div>
                                            : ''
                                    }
                                    {this.state.loading ?
                                        <div className="d-flex flex-column align-items-center justify-content-center w-100 h-50" style={{ padding: this.state.active === 'invoiced' || this.state.active === 'shipped' ? "15%" : "30%" }}>
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                                        </div> :
                                        this.state.active === 'invoiced' ?
                                            <div>
                                                <div>
                                                    <div className="d-flex flex-column item-list">
                                                        <div className="data-list">
                                                            {
                                                                this.state.isBackToTop ?
                                                                    <div className="scroll-top d-flex align-items-center justify-content-center clickable" style={{ right: `${window.innerWidth - this.state.pageClientWidth}px` }} onClick={() => this.scrollToTop('Up')}>
                                                                        <i className="fas fa-arrow-up"></i>
                                                                    </div> : null
                                                            }
                                                            {this.state.invoicelist.length > 0 ?
                                                                <Row xs={1}>
                                                                    {
                                                                        this.state.invoicelist.map((item, index) => {

                                                                            let detail = JSON.parse(item['details']);
                                                                            let bidderirm = detail.items.some(item => item.bidderirm === 'shipping')
                                                                            let getShippingItems = detail.items.filter(item => item.bidderirm === 'shipping') .map(item => ({
                                                                              id: item.id,
                                                                              itemtitle: item.title
                                                                            }));                                                                           
                                                                            detail.buyerid = item.buyerid;
                                                                            let locationid = detail.location
                                                                            let checkinvoice = item.invoiceview
                                                                            let isViewInvoice = item['invoicestatus'].toLowerCase() === "paid" ? true : item['invoicestatus'].toLowerCase() === "void" ? true : (item['pendingamount'] > 0) ? true : false
                                                                            let isViewInvoiceUnpaid = item['invoicestatus'].toLowerCase() !== "unpaid" ? true : false
                                                                            let isAutoDebit = (item['autoDebitStatus'] != null && (item['autoDebitStatus'].toLowerCase() === "started" || item['autoDebitStatus'].toLowerCase() === "completed")) ? true : false
                                                                            let paidAmount = (Number(item['invoiceamount']) - Number(item['pendingamount']))
                                                                            let invoiceType = item.type
                                                                            return (
                                                                                <Col key={`items_${index}`}>
                                                                                    <div id={`items_${index}`}>
                                                                                        <div className="content-container d-flex">
                                                                                            <div style={{ width: "100%" }} className={`right-side ${this.page === "won" ? '' : ''}`}>
                                                                                                <div className={`d-flex align-items-center header`}>
                                                                                                    {this.state.active === 'invoiced' &&
                                                                                                        <div>
                                                                                                            <div className={`custom-checkbox-div ${this.state.selectedInvoice.includes(item.id) ? 'checked' :  ''}`} onClick={() => this.onChangeInvoiceCheckBox(item, 'invoice')}></div>
                                                                                                        </div>
                                                                                                    }
                                                                                                    <div>
                                                                                                        <div style={{ marginLeft: '10px' }}>Invoice No- {item.invoicenumber}</div>
                                                                                                    </div>
                                                                                                    <div>
                                                                                                        <div style={{ marginLeft: '10px' }}>Date:- {item['createddate'] && `${moment.utc(item['createddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`}</div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="details d-flex flex-column align-items-start justify-content-around">
                                                                                                    <Row style={{ width: "100%" }}>
                                                                                                        <Col>
                                                                                                            <div className="response-view" style={{ alignSelf: "normal", paddingLeft: this.state.windowWidth > 425 ? "3%" : "11%" }}>
                                                                                                                {/* <div className={`d-flex flex-row right-row`} style={{ overflowWrap: "break-word", wordBreak: "break-all", overflow: "auto", height: "100px" }}> */}
                                                                                                                {/* <span dangerouslySetInnerHTML={{ __html: "invoicemessage" in detail ? JSON.parse(detail.invoicemessage).content.body : "" }} /> */}
                                                                                                                <Row>
                                                                                                                    <div style={{ color: "black", fontWeight: "800" }}>Name :</div>
                                                                                                                    <Col>
                                                                                                                        <div className="right-view">{detail['billingto'] && ` ${detail['billingto']['lastname']}, ${detail['billingto']['firstname']}`}</div>
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                                <Row>
                                                                                                                    <div style={{ color: "black", fontWeight: "800" }}>Phone :</div>
                                                                                                                    <Col>
                                                                                                                        <div className="right-view">{detail['billingto']['mobile'] ? detail['billingto']['mobile'] : '- - -'}</div>
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                                <Row>
                                                                                                                    <div style={{ color: "black", fontWeight: "800" }}>Email :</div>
                                                                                                                    <Col>
                                                                                                                        <div className="right-view">{detail['billingto']['email'] ? detail['billingto']['email'] : '- - -'}</div>
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                                <Row>
                                                                                                                    <div style={{ color: "black", fontWeight: "800" }}>Address :</div>
                                                                                                                    <Col>
                                                                                                                        <div className="right-view">
                                                                                                                            <span>{detail['billingto']['address1'] ? `${detail['billingto']['address1']}, ` : '- - -'}</span>
                                                                                                                            {detail['billingto']['address2'] ?
                                                                                                                                <span>{`${detail['billingto']['address2']}, `}</span> : ''}
                                                                                                                            {detail['billingto']['city'] ?
                                                                                                                                <span>{`${detail['billingto']['city']}, `}</span> : ''}
                                                                                                                            {detail['billingto']['state'] ?
                                                                                                                                <span>{`${detail['billingto']['state']}, `}</span> : ''}
                                                                                                                            {detail['billingto']['zipcode'] ?
                                                                                                                                <span>{`${detail['billingto']['zipcode']}`}</span> : ''}
                                                                                                                            {/* <span>{`${detail['billingto']['city']}, ${detail['billingto']['state']}, ${detail['billingto']['zipcode']}`}</span> */}
                                                                                                                        </div>
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                            </div>
                                                                                                        </Col>
                                                                                                        <Col style={{ paddingRight: this.state.windowWidth > 425 ? "0%" : "none" }}>
                                                                                                            <div className="d-flex flex-column">
                                                                                                                <div className="clickable " style={{ marginTop: this.state.windowWidth > 425 ? "none" : "3%", textAlign: this.state.windowWidth > 425 ? "end" : "center", float: this.state.windowWidth > 425 ? "right" : "none" }}>
                                                                                                                    {(item['invoicestatus']?.toLowerCase() === "unpaid" && paidAmount != 0 && item['pendingamount']) ? <Button className="btn-success process-view-btn" style={{ height: "fit-content", height: "-moz-fit-content", width: "200px", marginRight: "5px", marginBottom: "0px",backgroundColor: "#1d8296"  }} disabled={(typeof item['autoDebitStatus'] == "string" && ["initiated", "paypal restricted", "started", "pending"].includes(item['autoDebitStatus']?.toLowerCase())) || (typeof item['createdtype'] == "string" && item['createdtype']?.toLowerCase() == "manual" && typeof item['bidderacceptance'] == "string" && item['bidderacceptance']?.toLowerCase() != "accepted") || !this.state.processPaymentDisableButton || item?.['isinvoicependingprocessing']} onClick={() => this.processPayment(item.id, 'processpendinginvoiceamount')}>Process Balance Amount</Button> :
                                                                                                                        (item['invoicestatus']?.toLowerCase() === "unpaid" && paidAmount == 0 && invoiceType != "RA" && invoiceType!= "DG") ? <Button className="btn-success" style={{ height: "fit-content", height: "-moz-fit-content", width: "200px", marginRight: "5px",backgroundColor: "#1d8296" }}  disabled={(typeof item['autoDebitStatus'] == "string" && ["initiated", "paypal restricted", "started", "pending"].includes(item['autoDebitStatus']?.toLowerCase())) || (typeof item['createdtype'] == "string" && item['createdtype']?.toLowerCase() == "manual" && typeof item['bidderacceptance'] == "string" && item['bidderacceptance']?.toLowerCase() != "accepted") || !this.state.processPaymentDisableButton || item?.['isinvoiceprocessing']} onClick={() => this.processPayment(item.id, 'processpayment')}>Process Payment</Button> : ""}
                                                                                                                    <a href={this.viewInvoiceUrl(item.id, item.type)} onClick={this.aTagHandle}>
                                                                                                                        <Button
                                                                                                                            onClick={() => {
                                                                                                                                this.viewInvoice(item, index)
                                                                                                                            }}
                                                                                                                            className="" style={{ backgroundColor: "white", borderColor: "black", color: "black", fontWeight: "bold", width: "150px", }}>
                                                                                                                            {/* <Link to={{
                                                                                                                            pathname: `/invoice/view/${item['id']}`,
                                                                                                                            state: {
                                                                                                                                prevPath: this.props.history.location.pathname,
                                                                                                                                saletitle: this.props.location.state.saletitle,
                                                                                                                                state: this.state,
                                                                                                                                name: this.state.name
                                                                                                                            }
                                                                                                                        }}> */}
                                                                                                                            {((isViewInvoice || isAutoDebit) && isViewInvoiceUnpaid) || (paidAmount > 0) || invoiceType == "RA" || invoiceType == "DG" ? <div>View Invoice</div> : <div>View/Edit Invoice</div>}
                                                                                                                            {/* </Link> */}
                                                                                                                        </Button>
                                                                                                                    </a>
                                                                                                                </div>
                                                                                                                <div className="text-end">
                                                                                                                    {
                                                                                                                        !this.checkTaxExemption(item.buyerid, item.locationid) ? null :
                                                                                                                            <a href={this.taxExemptionUrl(item.buyerid)} onClick={this.aTagHandle}>
                                                                                                                                <Button className="mt-2" style={{ height: "fit-content", height: "-moz-fit-content", borderColor: "red", backgroundColor: "red", width: "150px", marginRight: this.state.windowWidth < 425 ? '17%' : '0%' }} onClick={() => this.navigateTaxExemption(item.buyerid, detail['billingto']['lastname'], detail['billingto']['firstname'],locationid, index)} >Tax Exemptions</Button>
                                                                                                                            </a>
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="text-end">
                                                                                                                {
                                                                                                                    this.checkTaxExemption(item.buyerid, item.locationid) ? null :
                                                                                                                        <Button className="mt-2" style={{ height: "fit-content", height: "-moz-fit-content", borderColor: "red", backgroundColor: "red", width: "150px", marginRight: this.state.windowWidth < 425 ? '17%' : '0%' }} onClick={() => this.navigateTaxExemption(item.buyerid, detail['billingto']['lastname'], detail['billingto']['firstname'], locationid)} >{item['taxexcempt'] == 1 ? 'Tax Exempted' : 'Tax Not Exempted'}</Button>
                                                                                                                }
                                                                                                            </div>
                                                                                                        </Col></Row>
                                                                                                    <hr className="hr-line"></hr>
                                                                                                    <div className="response-view" style={{ display: "flex", justifyContent: "space-between", alignSelf: "normal", }}>
                                                                                                        <div className={`d-flex flex-row right-row`} style={{ flexWrap: "wrap" }}>
                                                                                                            {/* <div>
                                                                                                                    <div className="bottom-head">Buyer</div>
                                                                                                                    <div className="bottom-body">{detail['billingto'] && `${detail['billingto']['lastname']}, ${detail['billingto']['firstname']}`}</div>
                                                                                                                </div> */}
                                                                                                            <div>
                                                                                                                <div className="bottom-head">Total Amount</div>
                                                                                                                <div className="bottom-body">$ {parseFloat(item['invoiceamount']).toFixed(2)}</div>
                                                                                                            </div>
                                                                                                            <div>
                                                                                                                <div className="bottom-head1">Pending</div>
                                                                                                                <div className="bottom-body1">{item['pendingamount'] != null ? `$ ${parseFloat(item['pendingamount']).toFixed(2)}` : "- - -"}</div>
                                                                                                            </div>
                                                                                                         
                                                                                                           
                                                                                                            <div>
                                                                                                                <div className="bottom-head2">Status</div>
                                                                                                                <div style={{ fontWeight: "bold" }} className={`bottom-body2 ${item['invoicestatus'].toLowerCase() === "paid" ? 'text-success' : 'text-danger'}`}>{item['invoicestatus']}</div>
                                                                                                            </div>
                                                                                                            {typeof item['createdtype'] === "string" && item['createdtype'].toLowerCase() == "manual" ? <div>
                                                                                                                <div className="bottom-head">Add'l Service Accepted
                                                                                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>
                                                                                                                        {item['bidderacceptance'] != null ? (item['bidderacceptance'].toLowerCase() === "accepted" ? 'Accepted' : item['bidderacceptance'].toLowerCase() === "declined" ? 'Declined' : 'Not Accepted') : 'Not Accepted'}</Tooltip>}>
                                                                                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px", marginLeft: "5px", marginTop: '1.5px' }}></i>
                                                                                                                    </OverlayTrigger>
                                                                                                                </div>
                                                                                                                <div className={`bottom-body  ${item['bidderacceptance']?.toLowerCase() === "accepted" ? 'text-success' : 'text-danger'}`} style={{ fontWeight: "bold" }}>{item['bidderacceptance'] ? item['bidderacceptance'] : '- - - -'}</div>
                                                                                                            </div> : ''}
                                                                                                            <div>
                                                                                                                <div className="bottom-head" style={{ margin: '1% 15%' }}>Auto Charge
                                                                                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>
                                                                                                                        {item['autoDebitStatus'] != null ? (item['autoDebitStatus']?.toLowerCase() === "initiated" ? 'Auto Charge is Initiated' : item['autoDebitStatus']?.toLowerCase() === "failed" ? 'Auto charge processing failed' : item['autoDebitStatus']?.toLowerCase() === "completed" ? 'Autocharge completed' : item['autoDebitStatus']?.toLowerCase() === "paypal restricted" ? 'Auto charge not availble for restricted items' : '') : 'Not applicable'}</Tooltip>}>
                                                                                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px", marginLeft: "5px", marginTop: '1.5px' }}></i>
                                                                                                                    </OverlayTrigger>
                                                                                                                </div>
                                                                                                                <div style={{ fontWeight: "bold", margin: '1% 15%' }} className={`bottom-body ${item['autoDebitStatus'] != null && (item['autoDebitStatus']?.toLowerCase() === "started" || item['autoDebitStatus']?.toLowerCase() === "completed") ? 'text-success' : 'text-danger'}`}>{item['autoDebitStatus'] ? item['autoDebitStatus'] : '----'}</div>
                                                                                                            </div>
                                                                                                            <div style={{ width : "100px", whiteSpace: "nowrap", marginLeft: '20px'}}>
                                                                                                                <div   className="bottom-head1">Email Sent</div>
                                                                                                                <div className="bottom-body1">{item.emailsent ? "Yes" : "No"} { item.emailsent ?
                                                                                                             <span style={{ fontWeight: "bold", margin: '1% 10%' }} className="bottom-body" onClick={ ()=> {this.getEmailBounceData(item.id)} }>
                                                                                                             <img style={{ cursor: "pointer", width: "24px" }} src={`${process.env.PUBLIC_URL}/static/images/transaction_status.png`} alt="drop-down" />
                                                                                                         </span> : ''    
                                                                                                            }</div>
                                                                                                            </div>
                                                                                                            { item['autoDebitStatus']!= null ? 
                                                                                                                <div style={{  whiteSpace: "nowrap", marginLeft: '10px' }}>
                                                                                                                    <div className="bottom-head3" style={{ margin: '1% 10%' }}>Transaction History</div>
                                                                                                                    <div style={{ fontWeight: "bold", margin: '1% 10%' }} className="bottom-body" onClick={ ()=> {this.getTransactionList(item.id)} }>
                                                                                                                        <img style={{ cursor: "pointer", width: "25px" }} src={`${process.env.PUBLIC_URL}/static/images/transaction_status.png`} alt="drop-down" />
                                                                                                                    </div>
                                                                                                                </div> : ''
                                                                                                            }

                                                                                                            { (this.state.saleShippingSaint && detail.items.length > 0)|| (bidderirm  &&  item['type'] !== 'RA' && item['type'] !== 'DG')  ? 
                                                                                                                <div style={{  whiteSpace: "nowrap", marginLeft: '10px' }}>
                                                                                                                    <div className="bottom-head3" style={{ margin: '1% 10%' }}>Fulfillment</div>
                                                                                                                    <div style={{ fontWeight: "bold", margin: '1% 10%' }} className="bottom-body" onClick={ ()=> {this.fullfillmentDetails(item.id, getShippingItems, item['invoicestatus'])} }>
                                                                                                                       <img style={{ cursor: "pointer", width: "25px" }} src={`${process.env.PUBLIC_URL}/static/images/transaction_status.png`} alt="drop-down" />
                                                                                                                    </div>
                                                                                                                </div> : ''
                                                                                                            }

                                                                                                        </div>
                                                                                                        <div className="arrow-right clickable " style={{ alignItems: "end", alignSelf: "center" }}>
                                                                                                            <Button disabled={ detail['items'].length === 0 } style={{ width: "150px" }}
                                                                                                                onClick={() => {
                                                                                                                    this.getInvoiceItemList(detail, index, checkinvoice, invoiceType)
                                                                                                                }}
                                                                                                                className="save-button ml-1">
                                                                                                                <div>View Items {this.state.itemViewLoader === index && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
                                                                                                                </div>
                                                                                                            </Button>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                            )
                                                                        }
                                                                        )
                                                                    }
                                                                </Row>
                                                                :
                                                                <div style={{ padding: "15% 2%", textAlign: "center", color: "black", fontSize: "14px", }}>No results found, please try your search again</div>
                                                            }
                                                        </div>
                                                    </div>

                                                    {
                                                        this.state.nextList && this.state.active !== 'DG' && this.state.active !== 'mir' && this.state.active !== 'shipped' ?
                                                            <div className="d-flex align-items-center browse-all-main justify-content-center">
                                                                <div className={`browse-all clickable ${this.state.nextList ? '' : 'custom-disable'} ${this.state.loaderForMore ? 'custom-disable' : ''}`} onClick={this.getMoreList}>
                                                                    More {this.state.loaderForMore ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                                                </div>
                                                            </div> : null
                                                    }
                                                </div>
                                            </div>
                                            :
                                            <div className="d-flex flex-column item-list" style={{ padding: "0px" }}>

                                                <div className="d-flex align-items-center justify-content-between" style={{ paddingBottom: "18px" }}>
                                                    {/* <div className="d-flex align-items-center justify-content-start" >
                                                        <div className="text-muted">
                                                            Sort by
                                                        </div>
                                                        <div className="mx-1" style={{ width: "150px" }}>
                                                            <Form.Group className="remove-bottom" controlId="formGridState">
                                                                <Form.Control as="select" className="sort" value={this.state.sort[0].direction} onChange={(event) => this.setSort(event)}>
                                                                    <option value="asc">Item Name A-Z  </option>
                                                                    <option value="desc">Item Name Z-A  </option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </div>
                                                    </div> */}
                                                    <div className="invoiced" style={{ width: this.state.windowWidth < 425 ? this.state.windowWidth - 30 : "100%", marginLeft: this.state.windowWidth < 425 ? "1%" : "0%" }}>
                                                        {this.state.active === 'all-items' || this.state.active === 'auction' || this.state.active === 'direct-buy' || this.state.active === 'onsite-only' || this.state.active === 'bought' || this.state.active === 'notsold' || this.state.active === 'available' || this.state.active === 'pending' || this.state.active === 'mir' || this.state.active === 'DG'  ?
                                                            <div className="invoice-search" style={{ marginTop: 0 }}>
                                                                <div className="invoice-list-search">
                                                                    <Form className="invoice-list-font">
                                                                        <div className="invoice-search-container">
                                                                            <Row>
                                                                                {this.state.windowWidth < 425 ?
                                                                                    <Col className={"px-1"}>

                                                                                        <Form.Group className="remove-bottom" controlId="formGridState">
                                                                                            <Form.Control onChange={(event) => this.selectdropStatus(event)} as="select" className="dropdowncolor" value={this.state.dropdownselect}>
                                                                                                <option value='all-items' className="dropdownoptioncolor"> All items ({this.state.totalCount}) </option>
                                                                                                <option value='auction' className="dropdownoptioncolor"> Auction  ({this.state.allCounts['Auction'] ? this.state.allCounts['Auction'] : 0})</option>
                                                                                                <option value='direct-buy' className="dropdownoptioncolor"> Direct Buy ({this.state.allCounts['Direct buy'] ? this.state.allCounts['Direct buy'] : 0}) </option>
                                                                                                <option value='onsite-only' className="dropdownoptioncolor"> Onsite Only ({this.state.allCounts['Onsite'] ? this.state.allCounts['Onsite'] : 0}) </option>
                                                                                                <option value='bought' className="dropdownoptioncolor"> Sold ({this.state.allCounts['Sold'] ? this.state.allCounts['Sold'] : 0}) </option>
                                                                                                <option value='notsold' className="dropdownoptioncolor"> Not Sold ({this.state.allCounts['Not Sold'] ? this.state.allCounts['Not Sold'] : 0}) </option>
                                                                                                <option value='invoiced' className="dropdownoptioncolor"> Invoiced ({this.state.allCounts['Invoiced'] ? this.state.allCounts['Invoiced'] : 0}) </option>
                                                                                                <option value='shipped' className="dropdownoptioncolor"> Shipped ({this.state.allCounts['Shipped'] ? this.state.allCounts['Shipped'] : 0}) </option>
                                                                                                <option value='pickup' className="dropdownoptioncolor"> Pickup ({this.state.allCounts['Pickup'] ? this.state.allCounts['Pickup'] : 0}) </option>
                                                                                                <option value='delivery' className="dropdownoptioncolor"> Delivery ({this.state.allCounts['Delivery'] ? this.state.allCounts['Delivery'] : 0}) </option>
                                                                                                <option value='available' className="dropdownoptioncolor"> Ready ({this.state.allCounts['Ready'] ? this.state.allCounts['Ready'] : 0}) </option>
                                                                                                <option value='pending' className="dropdownoptioncolor"> Pending ({this.state.allCounts['Pending'] ? this.state.allCounts['Pending'] : 0}) </option>
                                                                                                <option value='mir' className="dropdownoptioncolor"> Make It Returnable Status ({this.state.allCounts['RA'] ? this.state.allCounts['RA'] : 0})</option>
                                                                                                <option value='DG' className="dropdownoptioncolor">Delivery Guarantee Status ({this.state.allCounts['DG'] ? this.state.allCounts['DG'] : 0})</option>
                                                                                            </Form.Control>
                                                                                        </Form.Group>
                                                                                    </Col> : ""
                                                                                }
                                                                                <Col className={"px-1"}>
                                                                                    <label>Category</label>
                                                                                    <Form.Control as="select" name="categoryid" onKeyDown={this._handleKeyDown}  onChange={(event) => this.onInputChange(event)}>
                                                                                        <option value="">All</option>
                                                                                        {Object.keys(this.state.category).sort().map((category, index) =>
                                                                                            <optgroup key={index} label={category} style={{ backgroundColor: "#efefef" }}>
                                                                                                {
                                                                                                    this.state.category[category].length > 0 ?
                                                                                                        this.state.category[category].map((subcategory, subIndex) =>
                                                                                                            <option key={index + subIndex} value={subcategory} style={{ backgroundColor: "white" }} selected={
                                                                                                                this.state.itemSearch.categoryGroup.value === category &&
                                                                                                                this.state.itemSearch.categoryid.value === subcategory
                                                                                                              } >{subcategory}</option>
                                                                                                        ) :
                                                                                                        <option key={index + 'no' + index} disabled style={{ backgroundColor: "white" }}>- - - - -</option>
                                                                                                }
                                                                                            </optgroup>
                                                                                        )}
                                                                                    </Form.Control>
                                                                                </Col>
                                                                                <Col className={"px-1"}>
                                                                                    <label>Item Title</label>
                                                                                    <Form.Control type="text" name="title" onKeyDown={this._handleKeyDown} value={this.state.itemSearch.title.value} onChange={(event) => this.onInputChange(event)} />
                                                                                </Col>
                                                                                <Col className={"px-1"}>
                                                                                    <label>Search SKU</label>
                                                                                    <Form.Control type="text" name="SKU" onKeyDown={this._handleKeyDown} value={this.state.itemSearch.SKU.value} onChange={(event) => this.onInputChange(event)} />
                                                                                </Col>
                                                                               { this.state.active !== 'mir' && this.state.active !== 'DG'  ? <> <Col className={"px-1"}>
                                                                                    <label>Description</label>
                                                                                    <Form.Control type="text" name="description" onKeyDown={this._handleKeyDown} value={this.state.itemSearch.description.value} onChange={(event) => this.onInputChange(event)} />
                                                                                </Col>
                                                                                <Col className={"px-1"}>
                                                                                    <label>Item SKU</label>
                                                                                    <Form.Group className="remove-bottom" controlId="formGridState">
                                                                                        <Form.Control as="select" className={this.state.skusortValue ? "sort" : "optioncolor"} value={this.state.skusortValue} onChange={(event) => this.skusetSort(event)}>
                                                                                            <option value="" className="optioncolor" disabled> Order By  </option>
                                                                                            <option value="asc"> A-Z  </option>
                                                                                            <option value="desc"> Z-A  </option>
                                                                                        </Form.Control>
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col className={"px-1"}>
                                                                                    <label>Sort By </label>
                                                                                    <Form.Group className="remove-bottom" controlId="formGridState">
                                                                                        <Form.Control as="select" id="titlevalue" className={this.state.titlesortValue ? "sort" : "optioncolor"} value={this.state.titlesortValue} onChange={(event) => this.setSort(event)}>
                                                                                            <option value="" className="optioncolor" disabled> Order By  </option>
                                                                                            {this.state.active === 'available' ? <option value="5" >Item Closing Order Asc</option> : ''}
                                                                                            {this.state.active === 'available' ? <option value="6" >Item Closing Order Desc</option> : ''}
                                                                                            <option value="1"> Item Title A-Z  </option>
                                                                                            <option value="2"> Item Title Z-A  </option>
                                                                                            <option value="3"> Oldest to Newest  </option>
                                                                                            <option value="4"> Newest to Oldest </option>
                                                                                        </Form.Control>
                                                                                    </Form.Group>
                                                                                </Col> </> : ''}
                                                                            </Row>
                                                                            {this.state.windowWidth > 400 ?
                                                                                <Row className={"buttonClass"} style={{ marginTop: 15 }}>
                                                                                    <Col>
                                                                                        {this.state.active.includes('available') ?
                                                                                            <Button
                                                                                                onClick={() => {
                                                                                                    this.setState({
                                                                                                        ClosingOrderModal: true,
                                                                                                    })
                                                                                                }}
                                                                                                disabled={!this.state.SyncButtonEnable}
                                                                                                className='btn-success sync-btn'>Sync Item Closing Time</Button>
                                                                                            : ""}
                                                                                        <Button className="clear-button" disabled={this.state.issearch === false} onClick={() => {(this.state.active == 'mir'||this.state.active == 'DG' )? this.clearMir() :this.itemresetState()}}>Clear All</Button>
                                                                                        <Button variant="seller-search" disabled={this.state.issearch === false} onClick={() =>{(this.state.active == 'mir' || this.state.active == 'DG') ? this.searchMir() : this.itemenableSearch()}}>Search</Button>
                                                                                    </Col>
                                                                                </Row> :
                                                                                <Row className={"buttonClass"} style={{ marginTop: 15 }}>
                                                                                    <Col>
                                                                                        {this.state.active.includes('available') ?
                                                                                            <Button
                                                                                                onClick={() => {
                                                                                                    this.setState({
                                                                                                        ClosingOrderModal: true,
                                                                                                    })
                                                                                                }}
                                                                                                disabled={!this.state.SyncButtonEnable}
                                                                                                className='btn-success'>Sync item Closing time</Button>
                                                                                            : ""}
                                                                                    </Col>
                                                                                    <Col>
                                                                                        <Button className="clear-button" disabled={this.state.issearch === false} onClick={() => {(this.state.active == 'mir'||this.state.active == 'DG' )? this.clearMir() :this.itemresetState()}}>Clear All</Button>
                                                                                        <Button variant="search-button" disabled={this.state.issearch === false}  onClick={() =>{(this.state.active == 'mir' || this.state.active == 'DG') ? this.searchMir() : this.itemenableSearch()}}>Search</Button>
                                                                                    </Col>
                                                                                </Row>
                                                                            }
                                                                        </div>
                                                                    </Form>
                                                                </div>
                                                            </div>
                                                            : ''
                                                        }
                                                    </div>

                                                </div>

                                                <div>
                                                    <div>
                                                        <div className="data-list">
                                                            {
                                                                this.state.isBackToTop ?
                                                                    <div className="scroll-top d-flex align-items-center justify-content-center clickable" style={{ right: `${window.innerWidth - this.state.pageClientWidth}px` }} onClick={() => this.scrollToTop('Up')}>
                                                                        <i className="fas fa-arrow-up"></i>
                                                                    </div> : null
                                                            }
                                                            {this.state.totalCount > 0 && (this.state.active !== 'mir' && this.state.active !== 'DG' &&  this.state.active !== 'shipped' && this.state.active !== 'pickup' && this.state.active !== 'delivery')?
                                                                this.state.itemList?.length > 0 ?
                                                                    <Row xs={1}>

                                                                       {this.state.active === 'available'  || this.state.active === 'pending' ? <div className="d-flex">
                                                                            <div className="left-side d-flex align-items-center justify-content-center" style={{ width: '22%' }}>
                                                                            </div>
                                                                            <div className={`right-side`}>
                                                                                <Form.Check style={{ transform: 'scale(1.3)', marginRight: "7rem" }} id="selectall" name="selectall" className={`right-side`} inline type="checkbox" checked={this.state.selectedList?.length === this.state.itemList?.length && this.state.selectedList?.length !== 0} label="Select All" onChange={(event) => this.selectAllItem(event)} />
                                                                                <span className="custom-toaster danger">{this.state.selectAllMessage}</span>
                                                                            </div> 

                                                                        </div> : ''}

                                                                        {
                                                                            this.state.itemList.map((item, index) =>
                                                                                this.state.windowWidth > 425 ?
                                                                                    <Col key={`items_${index}`}>
                                                                                        
                                                                                        <div id={`items_${index}`}>
                                                                                            <div className="content-container d-flex">
                                                                                                <div className="left-side d-flex align-items-center justify-content-center">
                                                                                                    <img className="location-image" src={ item.thumbnailurl ? item.thumbnailurl : item.displayimageurl ? item.displayimageurl : `${process.env.PUBLIC_URL}/static/images/image_thumbnail.png`} style={{ width: item.displayimageurl ? '230px' : '100px', height: item.displayimageurl ? '150px' : '75px', }} alt="location"></img>
                                                                                                </div>
                                                                                                <div className={`right-side ${this.page === "won" ? '' : ''}`}>
                                                                                                    <div className={`d-flex align-items-center justify-content-between header`}>
                                                                                                        {this.state.status.toLowerCase() !== 'closed' && (this.state.active.includes('available') || this.state.active.includes('pending')) ?
                                                                                                            <div className="d-flex align-items-center">
                                                                                                                <div className={`custom-checkbox-div ${this.state.selectedList.includes(item.id) ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox(item)} style={{ marginRight: '5px' }}></div>
                                                                                                                {this.state.active.includes('available') ?
                                                                                                                    <>
                                                                                                                        <div className="mx-6 text-normal">Item Closing order</div>
                                                                                                                        <div className="page-size-conatiner" >
                                                                                                                            <Form.Control as="select" onChange={this.HandleClosingOrder} name={item.id}>
                                                                                                                                <option value="">0</option>
                                                                                                                                {
                                                                                                                                    this.state.ClosingorderOption.map((option, index) => <option key={index} value={option} disabled={this.state.itemcloseorderValue.includes(option)} selected={option == item.closingorder}>{option}</option>)
                                                                                                                                }
                                                                                                                            </Form.Control>
                                                                                                                        </div>
                                                                                                                    </> : ""}
                                                                                                            </div>
                                                                                                            : ''}
                                                                                                        <div>
                                                                                                            <div>{item.itemstatus}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="details d-flex flex-column align-items-start justify-content-around">
                                                                                                        <div className="w-100">
                                                                                                            <div className="title h5 text-bold" style={{ wordBreak: 'break-all' }}>
                                                                                                                {item.title}
                                                                                                            </div>
                                                                                                            {  (typeof item?.description === "string" && item?.description.replace( /(<([^>]+)>)/ig, '')?.length < 150 ) || !item?.description ?
                                                                                                                <div style={{ width: "auto", whiteSpace: "nowrap" }}>
                                                                                                                    <div style={{ overflowWrap: "break-word", wordBreak: "break-all", overflow: "hidden", height: "40px" }} dangerouslySetInnerHTML={{ __html: item.description }} />
                                                                                                                </div> :
                                                                                                                <div className="" style={{ flex: 1 }}>
                                                                                                                    <div className="descriptionO" style={{ width: "auto", maxWidth: "60vw", whiteSpace: "nowrap", }}>
                                                                                                                        <div className="message-wrap" style={{ overflowWrap: "break-word", wordBreak: "break-all", overflow: "hidden", height: "40px" }} dangerouslySetInnerHTML={{ __html: item.description }} />
                                                                                                                    </div>
                                                                                                                    <div style={{
                                                                                                                        display: "flex",
                                                                                                                        justifyContent: "flex-end"
                                                                                                                    }}>
                                                                                                                        <Button
                                                                                                                            onClick={() => {
                                                                                                                                this.setState({
                                                                                                                                    moreModal: true,
                                                                                                                                    moreData: item.description
                                                                                                                                })
                                                                                                                            }}
                                                                                                                            style={{ color: "#a02041", fontWeight: "bolder", fontSize: "15px", backgroundColor: "#FFF", borderWidth: 0, padding: 0 }}>More</Button>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            }
                                                                                                        </div>
                                                                                                        <hr className="hr-line"></hr>
                                                                                                        <div style={{ display: "flex", justifyContent: "space-between", alignSelf: "normal", }}>
                                                                                                            <div className={`d-flex flex-row right-row`} style={{ flexWrap: "wrap" }}>
                                                                                                                <div className="d-flex flex-row">
                                                                                                                    <div className="left-view">SKU : </div>
                                                                                                                    <div className="right-view" >{`${item.SKU}`}</div>
                                                                                                                </div>
                                                                                                                <div className="d-flex flex-row">
                                                                                                                    <div className="left-view">Category : </div>
                                                                                                                    <div className="right-view">{`${item.category}`}</div>
                                                                                                                </div>
                                                                                                                <div className="d-flex flex-row">
                                                                                                                    <div className="left-view">Shippable : </div>
                                                                                                                    <div className="right-view" >{`${item.isshippable > 0 ? "YES" : "NO"}`}</div>
                                                                                                                </div>
                                                                                                                <div className="d-flex flex-row">
                                                                                                                    <div className="left-view">Taxable : </div>
                                                                                                                    <div className="right-view" >{`${item.istaxable > 0 ? "YES" : "NO"}`}</div>
                                                                                                                </div>
                                                                                                                <div className="d-flex flex-row">
                                                                                                                    <div className="left-view">Featured : </div>
                                                                                                                    <div className="right-view" >{`${item.isfeatured > 0 ? "YES" : "NO"}`}</div>
                                                                                                                </div>
                                                                                                                {item.itemclosetime ?
                                                                                                                    <div className="d-flex flex-row">
                                                                                                                        <div className="left-view" style={{ maxWidth: "125px" }}>Item Closed Time : </div>
                                                                                                                        <div className="right-view" style={{ maxWidth: "200px" }}>{`${this.dateFormatCloseTime(item.itemclosetime)}`}</div>
                                                                                                                    </div>
                                                                                                                    : ''}
                                                                                                                {this.state.status.toLowerCase() !== 'closed' ?
                                                                                                                    <div className="d-flex flex-row">
                                                                                                                        <div className="left-view" style={{ maxWidth: "125px" }}>Current Bid Price : </div>
                                                                                                                        <div className="right-view" >{`${item.currentbidprice ? '$' + this.convertingToDecimal(item.currentbidprice) : '- - -'}`}</div>
                                                                                                                    </div>
                                                                                                                    :
                                                                                                                    <div className="d-flex flex-row">
                                                                                                                        <div className="left-view">Sold Price : </div>
                                                                                                                        <div className="right-view" >{`${item.soldprice ? '$' + this.convertingToDecimal(item.soldprice) : '- - -'}`}</div>
                                                                                                                    </div>
                                                                                                                }
                                                                                                            </div>
                                                                                                            <div className="arrow-right clickable " style={{ alignItems: "end", }}>
                                                                                                                {/* <OverlayTrigger overlay={<Tooltip id="tooltip-notes">Notes</Tooltip>}>
                                                                                                                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/notes.svg`} alt="notes" className="action-button" onClick={(event) => this.viewNotes(item.id)} />
                                                                                                                    </OverlayTrigger> */}
                                                                                                                <OverlayTrigger overlay={<Tooltip id="tooltip-view">View</Tooltip>}>
                                                                                                                    {/* <Link to= {{ pathname: `${salesDashboard}/${this.state.salesId}/itemsview/${item.id}`, state: { saletitle: this.props.location?.state?.saletitle, prevDatatable: this.props.location?.state?.datatable, state: this.state } }}> */}
                                                                                                                    <a href={this.itemViewUrl(item['id'])} onClick={this.aTagHandle}>
                                                                                                                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/view.svg`} alt="view" className="action-button" onClick={(event) => this.viewSales(item.id, index, event)} />
                                                                                                                    </a>
                                                                                                                    {/* </Link> */}
                                                                                                                </OverlayTrigger>
                                                                                                                <OverlayTrigger overlay={<Tooltip id="tooltip-edit">Edit</Tooltip>}>
                                                                                                                    {/* <Link
                                                                                                                        to={{
                                                                                                                            pathname: `/sales/items/edit/${item['id']}`
                                                                                                                        }}
                                                                                                                        > */}
                                                                                                                    <a href={this.editItemUrl(item['id'])} onClick={this.aTagHandle}>
                                                                                                                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/edit.svg`} alt="edit" className="action-button" onClick={(event) => this.editItem(item, index, event)} />
                                                                                                                    </a>
                                                                                                                    {/* </Link> */}
                                                                                                                </OverlayTrigger>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Col> :

                                                                                    <Col key={`items_${index}`} style={{ paddingBottom: "10px", paddingLeft: this.state.windowWidth < 425 ? "0px" : "15px" }}>
                                                                                        <div id={`items_${index}`}>
                                                                                            <div style={{ width: this.state.windowWidth - 34, border: "1px solid #c5c5c5" }}>
                                                                                                <div className="">
                                                                                                    <div className="" style={{ marginTop: "3%", marginBottom: "3%" }}>
                                                                                                        <img className="location-image" src={item.displayimageurl ? item.displayimageurl : `${process.env.PUBLIC_URL}/static/images/image_thumbnail.png`} style={{ width: item.displayimageurl ? this.state.windowWidth - 30 : '225px', height: item.displayimageurl ? '150px' : '100px', paddingLeft: item.displayimageurl ? "0px" : "100px", objectFit: "contain" }} alt="location"></img>
                                                                                                    </div>
                                                                                                    <div className={`${this.page === "won" ? '' : ''}`} style={{ backgroundColor: "#efefef", paddingTop: "1%" }}>
                                                                                                        <div className="" >
                                                                                                            {this.state.status.toLowerCase() !== 'closed' && (this.state.active.includes('available') || this.state.active.includes('pending')) ?
                                                                                                                <div style={{ float: "right", paddingRight: "15px" }}>
                                                                                                                    <div className={`custom-checkbox-div ${this.state.selectedList.includes(item.id) ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox(item)}></div>
                                                                                                                </div>
                                                                                                                : ''}
                                                                                                            <div className={`flex-row right-row`} style={{ marginLeft: "15px", marginTop: "15px" }}>
                                                                                                                <div className="d-flex flex-row" style={{ paddingBottom: "5px" }}>
                                                                                                                    {this.state.active.includes('available') ? <div className="d-flex align-items-center" style={{ marginRight: '20px' }}> Item Closing Order</div> : ''}

                                                                                                                    {this.state.active.includes('available') ?
                                                                                                                        <>
                                                                                                                            {/* <div className="mx-6 text-normal">Item Closing order</div> */}
                                                                                                                            <div className="page-size-conatiner">
                                                                                                                                <Form.Control as="select" onChange={this.HandleClosingOrder} name={item.id}>
                                                                                                                                    <option value="">0</option>
                                                                                                                                    {
                                                                                                                                        this.state.ClosingorderOption.map((option, index) => <option key={index} value={option} disabled={this.state.itemcloseorderValue.includes(option)} selected={option == item.closingorder}>{option}</option>)
                                                                                                                                    }
                                                                                                                                </Form.Control>
                                                                                                                            </div>
                                                                                                                        </> : ""}
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className={`flex-row right-row`} style={{ marginLeft: "15px", marginTop: "15px" }}>
                                                                                                                <div className="d-flex flex-row" style={{ paddingBottom: "5px" }}>
                                                                                                                    <div className="left-view" style={{ width: "30%" }}>Item Status </div>
                                                                                                                    <div style={{ color: "black", fontWeight: "800", paddingLeft: "5%" }}>
                                                                                                                        {item.itemstatus}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="w-100">
                                                                                                            <div className="w-100">
                                                                                                                <div className={`flex-row right-row`} style={{ marginLeft: "15px" }}>
                                                                                                                    <div className="d-flex flex-row" style={{ paddingBottom: "5px" }}>
                                                                                                                        <div className="left-view" style={{ width: "70%" }}>Item Title </div>
                                                                                                                        <div style={{ color: "black", fontWeight: "800", paddingLeft: "5%", wordBreak: "break-word" }}>
                                                                                                                            {`${item.title}`}
                                                                                                                        </div></div></div>
                                                                                                                { typeof item?.description === "string" && item.description.length < 56 ?
                                                                                                                    <div className="">
                                                                                                                        <div className={`flex-row right-row`} style={{ marginLeft: "15px" }}>
                                                                                                                            <div className="d-flex flex-row" style={{ paddingBottom: "5px" }}>
                                                                                                                                <div className="left-view" style={{ width: "25%" }}>Description </div>
                                                                                                                                <div style={{ overflowWrap: "break-word", wordBreak: "break-all", overflow: "hidden", height: "40px", }}>
                                                                                                                                    {item.description.length ? <span id="description" style={{ color: "black", fontWeight: "800" }} dangerouslySetInnerHTML={{ __html: item.description }} /> : <p id="description" style={{ color: "black", fontWeight: "800", paddingLeft: "11%", width: "170px" }}>- - -</p>}</div></div>
                                                                                                                        </div></div> : <div className="">
                                                                                                                        <div className={`flex-row right-row`} style={{ marginLeft: "15px" }}>
                                                                                                                            <div className="" style={{ paddingBottom: "5px" }}>
                                                                                                                                <div className="left-view" >Description </div>
                                                                                                                                <div style={{ overflowWrap: "break-word", wordBreak: "break-all", overflow: "hidden", height: "40px" }}>
                                                                                                                                    <span id="description-dangerouslyhtml" style={{ color: "black", fontWeight: "800", }} dangerouslySetInnerHTML={{ __html: item.description }} />
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                        <div style={{
                                                                                                                            display: "flex",
                                                                                                                            justifyContent: "flex-end"
                                                                                                                        }}>
                                                                                                                            <Button
                                                                                                                                onClick={() => {
                                                                                                                                    this.setState({
                                                                                                                                        moreModal: true,
                                                                                                                                        moreData: item.description
                                                                                                                                    })
                                                                                                                                }}
                                                                                                                                style={{ color: "#a02041", fontWeight: "bolder", fontSize: "15px", backgroundColor: "#FFF", borderWidth: 0, padding: 0 }}>More</Button>
                                                                                                                        </div>
                                                                                                                    </div>}
                                                                                                            </div>
                                                                                                            <div>
                                                                                                                <div className={`flex-row right-row`} style={{ marginLeft: "15px" }}>
                                                                                                                    <div className="d-flex flex-row" style={{ paddingBottom: "5px" }}>
                                                                                                                        <div className="left-view" style={{ width: "25%" }}>SKU </div>
                                                                                                                        <div style={{ color: "black", fontWeight: "800", paddingLeft: "5%" }}>{`${item.SKU}`}</div>
                                                                                                                    </div>
                                                                                                                    <div className="d-flex flex-row" style={{ paddingBottom: "5px" }}>
                                                                                                                        <div className="left-view" style={{ width: "25%" }}>Category </div>
                                                                                                                        <div style={{ color: "black", fontWeight: "800", paddingLeft: "5%" }}>{`${item.category}`}</div>
                                                                                                                    </div>
                                                                                                                    <div className="d-flex flex-row" style={{ paddingBottom: "5px" }}>
                                                                                                                        <div className="left-view" style={{ width: "25%" }}>Shippable </div>
                                                                                                                        <div style={{ color: "black", fontWeight: "800", paddingLeft: "5%" }}>{`${item.isshippable > 0 ? "YES" : "NO"}`}</div>
                                                                                                                    </div>
                                                                                                                    <div className="d-flex flex-row" style={{ paddingBottom: "5px" }}>
                                                                                                                        <div className="left-view" style={{ width: "25%" }}>Taxable </div>
                                                                                                                        <div style={{ color: "black", fontWeight: "800", paddingLeft: "5%" }} >{`${item.istaxable > 0 ? "YES" : "NO"}`}</div>
                                                                                                                    </div>
                                                                                                                    <div className="d-flex flex-row" style={{ paddingBottom: "5px" }}>
                                                                                                                        <div className="left-view" style={{ width: "25%" }}>Featured </div>
                                                                                                                        <div style={{ color: "black", fontWeight: "800", paddingLeft: "5%" }}>{`${item.isfeatured > 0 ? "YES" : "NO"}`}</div>
                                                                                                                    </div>
                                                                                                                    {item.itemclosetime ?
                                                                                                                        <div className="d-flex flex-row" style={{ paddingBottom: "20px" }}>
                                                                                                                            <div className="left-view" style={{ maxWidth: "90px" }}>Item Closed Time  </div>
                                                                                                                            <div className="right-view" style={{ maxWidth: "200px", alignSelf: "center" }}>{`${this.dateFormatCloseTime(item.itemclosetime)}`}</div>
                                                                                                                        </div>
                                                                                                                        : ''}
                                                                                                                    {this.state.status.toLowerCase() !== 'closed' ?
                                                                                                                        <div className="d-flex flex-row">
                                                                                                                            <div className="left-view" style={{ maxWidth: "90px" }}>Current Bid Price </div>
                                                                                                                            <div className="right-view" >{`${item.currentbidprice ? '$' + this.convertingToDecimal(item.currentbidprice) : '- - -'}`}</div>
                                                                                                                        </div>
                                                                                                                        :
                                                                                                                        <div className="d-flex flex-row">
                                                                                                                            <div className="left-view">Sold Price : </div>
                                                                                                                            <div className="right-view" >{`${item.itemsoldprice ? '$' + this.convertingToDecimal(item.itemsoldprice) : '- - -'}`}</div>
                                                                                                                        </div>
                                                                                                                    }
                                                                                                                </div>
                                                                                                                <div className="arrow-right clickable " style={{ alignItems: "end", float: "right", marginTop: "-30px" }}>
                                                                                                                    <OverlayTrigger overlay={<Tooltip id="tooltip-view">View</Tooltip>}>
                                                                                                                        {/* <Link to= {{ pathname: `${salesDashboard}/${this.state.salesId}/itemsview/${item.id}`, state: { saletitle: this.props?.location?.state?.saletitle, prevDatatable: this.props?.location?.state?.datatable, state: this.state } }}> */}
                                                                                                                        <a href={this.viewInvoiceUrl(item.id)} onClick={this.aTagHandle}>
                                                                                                                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/view.svg`} alt="view" className="action-button" onClick={(event) => this.viewSales(item.id, index, event)} />
                                                                                                                        </a>
                                                                                                                        {/* </Link> */}
                                                                                                                    </OverlayTrigger>
                                                                                                                    <OverlayTrigger overlay={<Tooltip id="tooltip-edit">Edit</Tooltip>}>
                                                                                                                        {/* <Link
                                                                                                        to={{
                                                                                                            pathname: `/sales/items/edit/${item['id']}`,
                                                                                                            state: {
                                                                                                                prevPath: this.props.history?.location?.pathname,
                                                                                                                saletitle: this.props.location?.state?.saletitle,
                                                                                                                prevDatatable: this.props.location?.state?.datatable,
                                                                                                                state: this.state
                                                                                                            }
                                                                                                        }}
                                                                                                        > */}
                                                                                                                        <a href={this.editItemUrl(item['id'])} onClick={this.aTagHandle}>
                                                                                                                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/edit.svg`} alt="edit" className="action-button" onClick={(event) => this.editItem(item, index, event)} />
                                                                                                                            {/* </Link> */}
                                                                                                                        </a>
                                                                                                                    </OverlayTrigger>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Col>

                                                                            )
                                                                        }
                                                                    </Row>
                                                                    :
                                                                    <div style={{ padding: "15% 2%", textAlign: "center", color: "black", fontSize: "14px", }}>No results found, please try your search again</div>

                                                                : this.state.active === 'mir'  ?  <Mir  props={this.props} filter={this.state.mirFilter} mirstatus={this.state.mirstatus} saleid={ this.state.salesId} state={this.state} ref={this.mirtable}/> : 
                                                                this.state.active === 'DG' ?  <GD props={this.props} filter={this.state.mirFilter}  mirstatus={this.state.mirstatus} saleid={ this.state.salesId}  state={this.state} ref={this.mirtable}/> : 
                                                                this.state.active === 'pickup' ? <div style={{ width: '100%' }}>   <PickupItems filter={this.state.fullFillmentFilter} fullfillmentStatus={this.state.fullfillmentStatus}  saleid={ this.state.salesId}  state={this.state}  ref={this.mirtable}/> </div> :
                                                                this.state.active === 'shipped' ? <div style={{ width: '100%' }}>   <FullfillmentList filter={this.state.fullFillmentFilter} fullfillmentStatus={this.state.fullfillmentStatus}  saleid={ this.state.salesId}  state={this.state}  ref={this.mirtable} irm="ship"/> </div> : 
                                                                this.state.active === 'delivery' ? <div style={{ width: '100%' }}>   <FullfillmentList filter={this.state.fullFillmentFilter} fullfillmentStatus={this.state.fullfillmentStatus}  saleid={ this.state.salesId}  state={this.state}  ref={this.mirtable} irm="deliver"/> </div> : 

                                                                <div style={{ padding: "15% 2%", textAlign: "center", color: "black", fontSize: "14px", }}>No Data Available</div> 
                                                            }{
                                                                this.state.nextList && this.state.active !== 'DG' && this.state.active !== 'mir' && this.state.active !== 'shipped'  && this.state.active !== 'pickup'  ?
                                                                    <div className="d-flex align-items-center browse-all-main justify-content-center">
                                                                        <div className={`browse-all clickable ${this.state.nextList ? '' : 'custom-disable'} ${this.state.loaderForMore ? 'custom-disable' : ''}`} onClick={this.getMoreList}>
                                                                            More {this.state.loaderForMore ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                                                        </div>
                                                                    </div> : null
                                                            }
                                                        </div></div>


                                                </div>
                                            </div>
                                    }
                                </div>

                                {this.state.modal ?
                                    <Notes modal={this.state.modal} id={this.id} name='item' data={this.state.itemsDetails} hideNotes={this.hideNotes} /> : ''
                                }
                                <Modal centered size="mg" show={this.state.statusChangeModal} id="itemchange" onHide={() => { this.setState({ ...this.state }) }}>
                                    <Modal.Body>
                                        {/* <h5 className="text-secondary"> {this.state.selectedButton === 'all' ? 'Change Status' : 'Item Status Change'}</h5> */}
                                        {this.state.statusMessage ? <>
                                            <div className="text-center">
                                                {this.state.statusMessage}
                                            </div>
                                            <div className="d-flex justify-content-center mt-4">
                                                <Button onClick={() => this.statusChangeCancel()} className="btn-secondary mx-1">Cancel</Button>
                                            </div>
                                        </> : 
                                        <Form>
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                                                <Button style={{  backgroundColor: "#e3e3e3b5",  borderColor: "#ced4da",  color: "black" }}>
                                                    Select an Action
                                                </Button>
                                                <Form.Control as="select" name="statusType" value={this.state.changeStatusValue}  style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, width: "50%", margin: "2% 0%", height: "100%" }}
                                                    onChange={(event) => { this.onChangeStatus(event) }} >
                                                    <option value='' disabled>Select an Action</option>
                                                    {Object.entries(this.statusList).map(([key, value]) => (
                                                        <option key={key} value={key}>
                                                            {value}
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                            </div>
                                            <div style={{ minHeight: '100px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                                {
                                                    this.state.changeStatusValue === 'status' && 
                                                        <>
                                                        {this.state.statusMessage ? <div className="text-center"> {this.state.statusMessage} </div> :
                                                        <>
                                                            <div className="d-flex flex-column" style={{ padding: '0% 12%' }}>
                                                                <h5 className="text-muted mt-3">Status Change</h5>
                                                            </div>
                                                            <div>
                                                                <h5 style={{ textAlign: 'center', margin: '1% 0%', color: 'black', fontWeight: '-moz-initial' }}>
                                                                    {`Do you want to change ${this.state.selectedButton === 'all' ? 'all' : 'selected'} items to `}
                                                                    <h5 style={{ fontWeight: 'bolder' }}>{`${this.state.active === 'available' ? 'Pending' : 'Ready'} Status?`}</h5>
                                                                </h5>
                                                            </div>
                                                            </>}
                                                        </>

                                                }

                                                {
                                                    this.state.changeStatusValue === 'itemreceiptmethod' && (
                                                        <>
                                                            <div className="d-flex flex-column">
                                                                <h5 className="text-muted mt-3" style={{ padding: '0% 12%' }}>Item Receipt Methods</h5>
                                                            </div>
                                                            <div style={{ textAlign: 'center' }}>
                                                                <Form.Check inline type="checkbox" checked={this.state.saleitemreceiptmethod.pickup} disabled={!this.state.saleIrmcheck.pickup} name="pickup" label="Pickup" id="ispickup" onChange={this.receiptCheckBox} />
                                                                <Form.Check inline type="checkbox" checked={this.state.saleitemreceiptmethod.delivery} disabled={!this.state.saleIrmcheck.delivery} name="delivery" label="Delivery" id="isdelivery" onChange={this.receiptCheckBox} />
                                                                <Form.Check inline type="checkbox" checked={this.state.saleitemreceiptmethod.shipping} disabled={!this.state.saleIrmcheck.shipping} name="shipping" label="Shipping" id="isshipping" onChange={this.receiptCheckBox} />
                                                            </div>
                                                        </>
                                                    )
                                                }

                                                {
                                                    this.state.changeStatusValue === 'tax' && (
                                                        <div style={{ padding: '0% 12%' }}>
                                                            <div className="d-flex flex-column">
                                                                <h5 className="text-muted mt-3">Update Item Tax(%)</h5>
                                                            </div>
                                                            <div className="d-flex">
                                                                <Form.Control type="text" id="reserveprice" name="itemTax" value={this.state.itemTax} placeholder=" " onChange={this.inputChange} />
                                                            </div>
                                                        </div>
                                                    )
                                                }

                                                {
                                                    this.state.changeStatusValue === 'buyerspremium' && (
                                                        <div style={{ padding: '0% 12%' }}>
                                                            <div className="d-flex flex-column">
                                                                <h5 className="text-muted mt-3">Update Buyer's Premium(%)</h5>
                                                            </div>
                                                            <div className="d-flex">
                                                                <Form.Control type="text" id="reserveprice" name="itemBp" value={this.state.itemBp} placeholder=" " onChange={this.inputChange} />
                                                            </div>
                                                        </div>
                                                    )
                                                }

                                                {
                                                    this.state.changeStatusValue === 'istaxable' && (
                                                        <div style={{ padding: '0% 12%' }}>
                                                            <div className="mt-3">
                                                                <div className="d-flex">
                                                                <Form.Check style={{ justifyContent: 'center', width: '100%' }} inline type="checkbox"  checked={!this.state.itemistaxable} label="Item taxable" id="istaxable"  onChange={(event) => this.setState({ itemistaxable: !event.target.checked })}  />
                                                                <Form.Check style={{ justifyContent: 'center', width: '100%' }} inline type="checkbox"  checked={this.state.itemistaxable} label="Item not taxable" id="isnottaxable"  onChange={(event) => this.setState({ itemistaxable: event.target.checked })}  />
                                                                </div>
                                                                <p className="mt-3 " style={{color: '#A50050'}}>{this.state.itemistaxable ? "All selected items will be marked as item is not taxable" : "All selected items will be marked as item is taxable"}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                }

                                                {
                                                    this.state.changeStatusValue === 'sale' && this.state.showSale  ?
                                                    <>
                                                        { this.state.active === "pending" ? 
                                                        
                                                        <div style={{ padding: '0% 12%' }}>
                                                            <div className="mt-3">Select Location</div>
                                                            <Form.Control as="select" custom className="mb-2"  value={this.state.selectLocationId} onChange={this.selectLocation}>
                                                                <option style={{ display: "none" }} >Select Location &#42;</option>
                                                                {this.state.locationList.map((location, index) =>
                                                                    <option key={index} value={location.id}>{location.title}</option>
                                                                )}
                                                            </Form.Control>
                                                            {this.state.salesList.length >= 1 ?
                                                                <div className="d-flex mt-3">
                                                                    <Form.Control as="select" custom className="mb-2" value={this.state.selectedSale} onChange={this.selectSale}>
                                                                        <option style={{ display: "none" }} >Select Sales &#42;</option>
                                                                        {this.state.salesList.map((sale, index) =>
                                                                            <option key={index} value={sale.id}>{sale.title}</option>
                                                                        )}
                                                                    </Form.Control>
                                                                </div> : <div style={{ textAlign: 'center', color: '#A50050' }}>No sales are available.</div>
                                                            }
                                                        </div> : <p className="text-danger text-center">Items must be in Pending to move to another sale</p>}
                                                    </> : ''
                                                }

                                                 <div className={`d-flex flex-row ${this.state.invaliddata.show ? '' : 'justify-content-center text-center'}`}>
                                                    {
                                                        this.state.itemStatusToast.show ?
                                                            <ToasterMessage type={this.state.itemStatusToast.type} message={this.state.itemStatusToast.message} className="alert-handle mt-2"></ToasterMessage>
                                                            : null
                                                    }
                                                    {
                                                        this.state.invaliddata.show ?
                                                            <div className="error-message-box-main">
                                                                <div className="header-content">
                                                                    <div className="text-bold">Status could not be changed for the following items:</div>
                                                                    <div className="d-flex align-items-center details">
                                                                        <div className="w-25 text-bold">Item</div>
                                                                        <div className="mx-6 w-5">-</div>
                                                                        <div className="w-60 text-bold">Reason</div>
                                                                    </div>
                                                                </div>
                                                                <div className="error-message-box">
                                                                    {
                                                                        this.state.invaliddata.invaliddata.map((item, index) =>
                                                                            <div className={`${this.state.invaliddata.invaliddata.length == index + 1 ? "" : "border-b"} py-12`}>
                                                                                <div className="d-flex align-items-center">
                                                                                    <div style={{wordBreak: 'break-word'}} className="w-25">{item.title}</div>
                                                                                    <div className="mx-6 w-5">-</div>
                                                                                    <div className="60">{item.message}</div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                            : null
                                                    }
                                                </div>
                                            </div>
                                            <div className="mt-3">
                                               
                                                <div className="d-flex justify-content-center">
                                                    <Button onClick={() => this.statusChangeCancel()} className="btn-white">{this.state.invaliddata.invaliddata.length == 0 ? "No" : "Close"}</Button>
                                                    {
                                                        this.state.invaliddata.invaliddata.length == 0 ?
                                                            // <Button onClick={() => this.state.selectedButton === 'all' ? this.changeAllItemStatus() : this.confirmStatusChange()} disabled={this.state.statusType === this.state.selectedType || this.state.itemStatusToast.show || this.state.loading} className="btn-secondary ml-2">Yes{' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                                            <Button onClick={() => this.changeItemStatus()} disabled={this.state.statusType === this.state.selectedType || this.state.bulkValid || this.state.loading || this.state.changeStatusValue ==  "" } className="btn-secondary ml-2">Yes{' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>

                                                            : null
                                                    }
                                                </div>
                                            </div>
                                        </Form>}
                                    </Modal.Body>
                                </Modal>

                                <Modal size="xl" centered show={this.state.moreModal} id="moremodalview" style={{ maxHeight: "90%" }} onHide={() => { this.setState({ ...this.state }) }}>
                                    <Modal.Body>
                                        <div className="more-modal-close" >
                                            <Button style={{
                                                backgroundColor: "#FFF",
                                                color: "#7d7d7d",
                                                fontSize: "large",
                                                fontWeight: "bold",
                                                borderWidth: 0
                                            }} onClick={() => {
                                                this.setState({
                                                    moreModal: false,
                                                    moreData: ""
                                                })
                                            }} >X</Button>
                                        </div>
                                        <div style={{ overflowWrap: "break-word", wordBreak: "break-all", overflow: "auto" }}>
                                            <div className="message-wrap" style={{ fontSize: "16px" }} dangerouslySetInnerHTML={{ __html: this.state.moreData }} />
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer className="justify-content-center">
                                        <Button variant="secondary" onClick={() => this.setState({ moreModal: false, moreData: "" })}>Close</Button>
                                    </Modal.Footer>
                                </Modal>
                                <Modal size="sm" centered show={this.state.invoiceModal} id="invoiceModal" style={{ maxHeight: "90%" }} onHide={() => { this.setState({ ...this.state }) }}>

                                    <Modal.Body>
                                        <div className="modal-button">
                                            <div>
                                                <div style={{ fontWeight: "bolder", fontSize: "18px" }}>Send Invoice to</div>
                                                <div >
                                                    <div>
                                                        <div className="optionView" >
                                                            <div>
                                                                <Button style={{ backgroundColor: "white" }} onClick={() => { this.setState({ sendInvoiceOption: "unpaid-invoice" }) }} className="radio-button-outer">
                                                                    {this.state.sendInvoiceOption === "unpaid-invoice" && <div className="radio-button-inner"></div>}
                                                                </Button>
                                                            </div>
                                                            <div className="optionView-text">Unpaid Invoice</div>
                                                        </div>
                                                        <div className="optionView" >
                                                            <div>
                                                                <Button style={{ backgroundColor: "white" }} onClick={() => { this.setState({ sendInvoiceOption: "not-sent" }) }} className="radio-button-outer">
                                                                    {this.state.sendInvoiceOption === "not-sent" && <div className="radio-button-inner"></div>}
                                                                </Button>
                                                            </div>
                                                            <div className="optionView-text">Not Sent Email</div>
                                                        </div>
                                                        <div className="optionView" >
                                                            <div>
                                                                <Button style={{ backgroundColor: "white" }} onClick={() => { this.setState({ sendInvoiceOption: "paid-receipt" }) }} className="radio-button-outer">
                                                                    {this.state.sendInvoiceOption === "paid-receipt" && <div className="radio-button-inner"></div>}
                                                                </Button>
                                                            </div>
                                                            <div className="optionView-text">Paid Receipt</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-button">
                                            <Button onClick={() => {
                                                this.setState({
                                                    invoiceModal: false,
                                                })
                                            }}
                                                className="" style={{ backgroundColor: "white", borderColor: "black", color: "black", width: "100px" }}>
                                                <div>Cancel</div>
                                            </Button>
                                            <Button
                                                onClick={() => { this.sendInvoice(this.state.sendInvoiceOption) }}
                                                style={{ width: "100px" }} className="save-button ml-1">
                                                <div>Send {this.state.btnload && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}</div>
                                            </Button>
                                        </div>
                                    </Modal.Body>
                                </Modal>
                                <Modal size="xl" centered show={this.state.itemViewModal} id="itemViewModal" style={{ maxHeight: "90%" }} onHide={() => { this.setState({ ...this.state }) }}>
                                    <Modal.Body style={{ padding: 0, backgroundColor: "#f7f4f5" }}>
                                        <div>
                                            <Table responsive>
                                                <thead style={{
                                                    backgroundColor: "#00263E",
                                                    color:'white'
                                                }}>
                                                    <tr>
                                                        <th width="35%">Item</th>
                                                        <th>SKU</th>
                                                        { !this.state.invoiceview ? <th>IRM</th> : ''}
                                                        { this.state.ViewItemHandleStatus ? <th width="20%" >MIR Items <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Make It Returnable'}</Tooltip>}>
                                                            <i className={`fa fa-question-circle`} style={{ fontSize: "14px", color: "white" }}></i>
                                                        </OverlayTrigger> </th> : ''}
                                                        { this.state.ViewItemHandleStatus ? <th width="20%" >DG Items <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Delivery Guarantee Opted In'}</Tooltip>}>
                                                            <i className={`fa fa-question-circle`} style={{ fontSize: "14px", color: "white" }}></i>
                                                        </OverlayTrigger> </th> : ''}
                                                        <th>{this.state.viewItemsInvoiceType == "RA" ? 'MIR Amount' : this.state.viewItemsInvoiceType == "DG" ? 'DG Amount' : 'Amount'}</th>
                                                        {this.state.ViewItemHandleStatus ? <th>Tax</th> : ''}
                                                        {this.state.ViewItemHandleStatus ?<th>Tax Amount</th> : ''}
                                                        {this.state.ViewItemHandleStatus ?<th width="5%">BP</th> : ''}
                                                        {this.state.ViewItemHandleStatus ?<th>BP Amount</th>  : ''}
                                                        {this.state.ViewItemHandleStatus ? this.state.applytaxonbp ? <th>BP Tax Amount</th> : '' : ''}
                                                        <th>Gross Amount</th>
                                                        <th>
                                                            <Button style={{
                                                                backgroundColor: "#a50050",
                                                                color: "white",
                                                                fontSize: "large",
                                                                fontWeight: "bold",
                                                                borderWidth: 0
                                                            }} onClick={() => {
                                                                this.setState({
                                                                    itemViewModal: false,
                                                                    itemListData: [],
                                                                    ViewItemHandleStatus: false
                                                                })
                                                            }} >X</Button></th>
                                                    </tr>
                                                </thead>
                                                <tbody >
                                                    {
                                                        this.state.itemListData.map((item, index) => (
                                                            <tr>
                                                                <td>
                                                                    <img className="display-image" src={"thumbnailurl" in item && item.thumbnailurl ? item.thumbnailurl : item.url ? item.url : `${process.env.PUBLIC_URL}/static/images/image_thumbnail.png`} alt="item display"></img>
                                                                    <span style={{ wordBreak: "break-word", alignSelf: 'center', width: "65%" }}>
                                                                        {item['title'] !== "" ? item["title"] : "- - -"}
                                                                    </span>
                                                                </td>
                                                                <td style={{ fontWeight: 'bold', alignSelf: 'center' }}>{item['SKU'] ? item["SKU"] : "- - -"} </td>
                                                                {!this.state.invoiceview ? <td>{item['bidderirm'] ? capitalizeFirstLetter(item['bidderirm'])  : '- - -'}</td> : ''}
                                                                {this.state.ViewItemHandleStatus  ? <td>{item.mircheck ? item.mircheck : '- - -'}</td> : ''}
                                                                {this.state.ViewItemHandleStatus  ? <td>{item.dgcheck ? item.dgcheck : '- - -'}</td> : ''}
                                                                <td style={{ whiteSpace: 'nowrap' }}>{item['amount'] ? `$ ${parseFloat(item["amount"]).toFixed(2)}` : "- - -"} </td>
                                                                {this.state.ViewItemHandleStatus  ?<td style={{ whiteSpace: 'nowrap' }}>{item['tax'] ? `${item["tax"]} %` : "- - -"}</td> : '' }
                                                                {this.state.ViewItemHandleStatus  ?<td style={{ whiteSpace: 'nowrap' }}>{item['taxamount'] ? `$ ${parseFloat(item["taxamount"]).toFixed(2)}` : "- - -"} </td> : '' }
                                                                {this.state.ViewItemHandleStatus  ?<td style={{ whiteSpace: 'nowrap' }}>{item['buyerspremium'] ? `${item["buyerspremium"]} %` : "- - -"}</td> : '' }
                                                                {this.state.ViewItemHandleStatus  ?<td style={{ whiteSpace: 'nowrap' }}>{item['buyerspremiumamount'] ? `$ ${parseFloat(item["buyerspremiumamount"]).toFixed(2)}` : "- - -"} </td> : '' }
                                                                { this.state.ViewItemHandleStatus  ? this.state.applytaxonbp ?
                                                                <td style={{ whiteSpace: 'nowrap' }}>{item['taxonBPamount'] ? `$ ${parseFloat(item["taxonBPamount"]).toFixed(2)}` : "- - -"}</td> : '' : ''}
                                                                <td style={{ whiteSpace: 'nowrap' }}>{item['grossamount'] ? `$ ${parseFloat(item["grossamount"]).toFixed(2)}` : "- - -"} </td>
                                                                <td> </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Modal.Body>
                                </Modal>
                                <Modal centered show={this.state.ClosingOrderModal} onHide={() => { this.setState({ ...this.state }) }}>
                                    <Modal.Body>
                                        <h5 className="text-secondary"> {'Sync item Closing Time'}</h5>
                                        <h5 style={{ textAlign: "center", margin: "5% 0%", color: "black", fontWeight: "-moz-initial" }}>{`Do you want to`}<h5 style={{ fontWeight: "bolder" }}>{`Sync Item Closing Time to selected items?`}</h5></h5>
                                        <Form>
                                            <div className="mt-3">
                                                <div className="d-flex flex-row justify-content-center text-center">
                                                    {
                                                        this.state.itemStatusToast.show ?
                                                            <ToasterMessage type={this.state.itemStatusToast.type} message={this.state.itemStatusToast.message} className="alert-handle mt-2"></ToasterMessage>
                                                            : null
                                                    }
                                                </div>
                                                <div className="d-flex justify-content-center mt-3">
                                                    <Button
                                                        onClick={() => this.setState({ ClosingOrderModal: false })}
                                                        className="btn-white"
                                                    >No</Button>
                                                    <Button onClick={() => this.confirmClosingOrder()} disabled={this.state.loading} className="btn-secondary ml-2">Yes{' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                                </div>
                                            </div>
                                        </Form>
                                    </Modal.Body>
                                </Modal>
                                {/* Delete Confirmation Modal UI*/}
                                <Modal centered show={this.state.deleteModal} size="md" animation={false} onHide={() => { this.setState({ ...this.state }) }} keyboard={false}>
                                    <Modal.Body>
                                        <div className="d-flex flex-column justify-content-center align-items-center">
                                            Would you like to delete these Item(s) ?
                                            <div id="toaster" className={this.state.itemStatusToast.show ? " d-flex flex-row align-items-center justify-content-center toaster" : ''} style={{ paddingTop: "3%" }} >
                                                {
                                                    this.state.itemStatusToast.show ?
                                                        <ToasterMessage type={this.state.itemStatusToast.type} message={this.state.itemStatusToast.message} className="alert-handle"></ToasterMessage>
                                                        : null
                                                }
                                            </div>
                                            <div className="d-flex flex-row mt-4">
                                                <Button variant="outline-dark btn-white mx-2" style={{ width: '120px' }} onClick={() => { this.setState({ deleteModal: false, itemStatusToast: { show: false, type: '', message: '' } }) }}>Cancel</Button>
                                                <Button variant="secondary mx-2" style={{ width: '120px' }} disabled={this.state.itemStatusToast.type === 'success' || this.state.itemStatusToast.type === 'danger' || this.state.deleteLoading} onClick={() => this.deleteItems()}>Confirm {this.state.deleteLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                                            </div>
                                        </div>
                                    </Modal.Body>
                                </Modal>
                                <Modal centered show={this.state.pikcupDateModel} size="md" animation={false} onHide={() => { this.setState({ ...this.state }) }} keyboard={false}>
                                    <Modal.Body>
                                        <div className="d-flex flex-column justify-content-center align-items-center ">
                                        <h5 style={{ fontWeight: "bolder" }}>Do you want to change the Pickup Date </h5>
                                            <div className="saleSettings">
                                                    <div className="mt-3">
                                                      
                                                        <div className="">
                                                            <label onClick={e => this.start.state.open && e.preventDefault()
                                                            }>
                                                                <DatePicker ref={r => this.start = r}
                                                                   minDate={( this.state?.saledetails?.pickuptime && this.state?.saledetails?.pickuptime > new Date())  ? new Date(this.state?.saledetails?.pickuptime) :  new Date(this.state.saledetails?.endtime).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0) ?   new Date(new Date(this.state.saledetails?.endtime).setDate(new Date(this.state.saledetails?.endtime).getDate() + 1))  : new Date()} 
                                                                   openToDate={( this.state?.saledetails?.pickuptime && this.state?.saledetails?.pickuptime > new Date()) ?  new Date(moment(this.state?.salePickupDate)) : new Date(moment(this.state.saledetails?.endtime)) >= new Date() ?   new Date(new Date(this.state.saledetails?.endtime).setDate(new Date(this.state.saledetails?.endtime).getDate() + 1))  : new Date()} 
                                                                    name="pickuptime"
                                                                    className={` ${this.state.saledetails?.pickuptime ? 'form-control-active' : ''} `}
                                                                    dateFormat="MM/dd/yyyy"
                                                                    selected={this.state.saledetails?.pickuptime   && !isNaN(new Date(this.state.saledetails?.pickuptime).getTime()) ?  new Date(moment(this.state.salePickupDate)) : this.state.salePickupDate ?  new Date(moment(this.state.salePickupDate)) : null}
                                                                    value={this.state.salePickupDate ?new Date(moment(this.state.salePickupDate)) : this.state.salePickupDate ?  new Date(moment(this.state.salePickupDate)) : null} 
                                                                    onChange={(date) => this.changePickupDateValue(date)}
                                                                    onChangeRaw={(event) => event.preventDefault()}
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    showDisabledMonthNavigation
                                                                    timeIntervals={15}
                                                                    placeholderText="Select Date"
                                                                    dropdownMode="select"
                                                                    popperPlacement="bottom-start"
                                                                    popperModifiers={{
                                                                        flip: {
                                                                            behavior: ["bottom"] 
                                                                        },
                                                                        preventOverflow: {
                                                                            enabled: false 
                                                                        },
                                                                        hide: {
                                                                            enabled: false 
                                                                        }
                                                                    }}
                                                                    
                                                                    autoComplete="off" />
                                                                <i  className="fa fa-calendar pickup-date" aria-hidden="true"></i>
                                                            </label>
                                                        </div>
                                                    </div>
                                            </div>
                                            <div>
                                               { this.state.pickupTimeMsg ? <p style={{ color: '#528a3f' }} >{ this.state.pickupTimeMsg ? this.state.pickupTimeMsg : ''}</p> : null}
                                                                    
                                            </div>
                                            <div>
                                                { 
                                                    this.state.pickupTimeErrMsg.show ?
                                                    <ToasterMessage type={this.state.pickupTimeErrMsg.type} message={this.state.pickupTimeErrMsg.message} className="alert-handle"></ToasterMessage>
                                                    : null
                                                }
                                            </div>
                                            <div className="d-flex flex-row mt-3">
                                                <Button variant="outline-dark btn-white mx-2"  onClick={() => this.resetPickupDate()}>No, keep my current date</Button>
                                                <Button variant="secondary mx-2"onClick={() => this.confirmPickupdate()} disabled={this.state.pickupTimeLoading || this.state.checkPickupDate } >Yes, change my date {this.state.pickupTimeLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                            </div>
                                        </div>

                                    </Modal.Body>
                                </Modal>


                                <Modal centered show={this.state.TaxExemptModal} size="md" animation={false} onHide={() => { this.setState({ ...this.state }) }} keyboard={false}>
                                    <Modal.Body>
                                        <div className="d-flex flex-column justify-content-center align-items-center">
                                            There are Pending Tax Exemptions that need approval for this sale. Please click ‘Approve Tax Exemptions’ to address, or you may skip by clicking ‘Generate Invoices’ and Tax Exemptions will remain Pending.

                                            <div className="d-flex flex-row mt-4">
                                                <Button variant="outline-dark btn-white mx-2" onClick={() => { this.setState({ TaxExemptModal: false }) }}>Cancel</Button>
                                                <Button variant="outline-dark btn-white mx-2" style={{ width: '40%' }} onClick={() => { this.generateInvoice() }}>Generate Invoices</Button>
                                                <Button variant="secondary mx-2" style={{ width: '60%' }} onClick={() => this.props.history.push(`/buyer/pending-tax-exemption`)}>Approve Tax Exemptions {this.state.deleteLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                                            </div>
                                        </div>
                                    </Modal.Body>
                                </Modal>

                                <Modal size="xl" id="transactionModal" show={this.state.transactionModalShow} centered onHide={() => this.setState({ transactionModalShow: false })}>
                                    <Modal.Header closeButton>
                                        <h5 className="text-secondary"><b>Transaction History</b></h5>
                                    </Modal.Header>
                                    <Modal.Body>
                                    {this.state.transactionLoader ?
                                        <div className="transaction-loader-view">
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                                        </div> : 
                                        <Table responsive className="p-3">
                                            <tbody>
                                                <tr className=" header" >
                                                    <td>Ctbids Transaction Id</td>
                                                    <td>Date</td>
                                                    <td>Invoice Number</td>
                                                    <td>Transaction Type</td>
                                                    <td>Payment Mode</td>
                                                    <td>PayPal Transaction ID</td>
                                                    <td>PayPal Status</td>
                                                    <td>Amount</td>
                                                    <td>Notes</td>
                                                    <td>Response Code</td>
                                                </tr>
                                                
                                                     {
                                                    this.state.transactionData.length ?
                                                        this.state.transactionData.map(data =>
                                                            <tr>
                                                                <td>{data.referencenumber ? data.referencenumber : '- - -'}</td>
                                                                <td style={{ whiteSpace: "nowrap" }}>{data.createddate ? `${moment.utc(data.createddate).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}` : '- - -'}</td>
                                                                <td>{data.invoicenumber ? data.invoicenumber : '- - -'}</td>
                                                                <td>{data.credit ? 'Credit' : ''}</td>
                                                                <td>{data.paymentmode ? data.paymentmode : '- - -'}</td>
                                                                <td>{data.paymentreference ? data.paymentreference : '- - -'}</td>
                                                                <td>{data.paypalstatus ? data.paypalstatus.toLowerCase() : data.status ? data.status.toLowerCase() : '- - -'}</td>
                                                                <td style={{ whiteSpace: "nowrap" }}>{data.amount ? `$ ${data.amount.toFixed(2)}` : '- - -'}</td>
                                                                <td style={{ wordWrap: 'break-word' }}>{data.comments ? data.comments : 'Manual payment'}</td>
                                                                <td>{data.tranresponse ?
                                                                    <div>
                                                                        <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{this.getTransactionMessage(data.tranresponse)}</Tooltip>}>
                                                                            <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                                        </OverlayTrigger>
                                                                    </div> : '- - -'}
                                                                </td>
                                                            </tr>
                                                        ) :
                                                        <tr><td colSpan="10"><h5 className="noData" >No data available</h5></td></tr>
                                                }
                                            </tbody>
                                        </Table>
                                    }
                                    </Modal.Body>
                                </Modal>


                                <Modal size="xl" id="transactionModal" show={this.state.emailBounceModel} centered onHide={() => this.setState({ emailBounceModel: false })}>
                                    <Modal.Header closeButton>
                                        <h5 className="text-secondary"><b>Email History</b></h5>
                                    </Modal.Header>
                                    <Modal.Body>
                                    {this.state.emailbounceLoader ?
                                        <div className="transaction-loader-view">
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                                        </div> : 
                                        <Table responsive className="p-3">
                                            <tbody>
                                                <tr className=" header" >
                                                    <td style={{whiteSpace: 'nowrap', width: '15%'}}>Email Sent Date</td>
                                                    <td style={{whiteSpace: 'nowrap', width: '15%'}}>Source Email Address</td>
                                                    <td style={{whiteSpace: 'nowrap', width: '15%'}}>Destination Email Address</td>
                                                    <td style={{whiteSpace: 'nowrap', width: '15%'}}>Email Delivery Status</td>
                                                    <td style={{whiteSpace: 'nowrap', width: '15%'}}>Bounce Type</td>
                                                    <td>Reason</td>
                                                </tr>
                                                
                                                     {
                                                    this.state.emailBounceData.length ?
                                                        this.state.emailBounceData.map(data =>
                                                            <tr>
                                                                <td style={{whiteSpace: 'nowrap', width: '15%'}}>{data.time ? `${moment.utc(data.time).local().format('YYYY-MM-DD')}`   : '- - -'}</td>
                                                                <td sstyle={{whiteSpace: 'nowrap', width: '15%'}}>{data.source ? data.source  : '- - -'}</td>
                                                                <td sstyle={{whiteSpace: 'nowrap', width: '15%'}}>{data.destination ? this.emailValidation(data.destination)  : '- - -'}</td>
                                                                <td style={{whiteSpace: 'nowrap', width: '15%'}}>{data.status ?  data.status : '- - -'}</td>
                                                                <td style={{whiteSpace: 'nowrap', width: '15%'}}>{data.type ? data.type  : '- - -'}</td>
                                                                <td>{data.reason ?  this.clickEventCheck(data) : '- - -'}</td>
                                                              
                                                            </tr>
                                                        ) :
                                                        <tr><td colSpan="10"><h5 className="noData" >No data available</h5></td></tr>
                                                }
                                            </tbody>
                                        </Table>
                                    }
                                    </Modal.Body>
                                </Modal>

                                <Modal size="xl" id="transactionModal" show={this.state.fullfillmentstatus} centered onHide={() => this.setState({ fullfillmentstatus: false })}>
                                    <Modal.Header closeButton>
                                        <h5 className="text-secondary"><b>Fulfillment</b></h5>
                                    </Modal.Header>
                                    <Modal.Body>
                                    {this.state.fullfillmentloader ?
                                        <div className="transaction-loader-view">
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                                        </div> : 
                                        <Table responsive className="p-3">
                                            <tbody>
                                                <tr className=" header" >
                                                    <td style={{whiteSpace: 'nowrap', width: '20%'}}>Tracking Number</td>
                                                    <td>Shipping Vendor</td>
                                                    <td>Shipping Status</td>
                                                    <td>Carrier</td>
                                                    <td>Item Title</td>
                                                    <td>Notes</td>
                                                </tr>
                                                
                                                     { this.state.saleShippingSaint &&  this.state?.fullfillmentLength?.length == 0 && this.state.processPaymentDisableButton ? <tr><td colSpan="10"><div className="text-center text-danger">Fulfillment transaction is In Process and should complete within 20 minutes from invoice processing. If data is still not available, kindly contact <span style={{ color: '#A50050', cursor: 'pointer' }} onClick={() => navigateToHelpCenter(this.props.history)}>CTBids.com/help-center</span> </div></td></tr> :
                                                    this.state?.fullFillmentData?.length  ?
                                                        this.state.fullFillmentData.map(data =>
                                                           <tr>
                                                                <td style={{whiteSpace: 'nowrap', width: '20%'}}>{data.trackingnumber ? data.trackingnumber : '- - -'}</td>
                                                                <td>{(data.shippingvendor && (data.shippingvendor).toLowerCase() === 'shipping saint') ? <a style={{ color: 'blue' }} href='https://manage.shippingsaint.com/' target='_blank'> Shipping Saint </a> : data.shippingvendor ? data.shippingvendor :  'Seller'} </td>
                                                                <td>{data.shipmentstatus && this.state.saleShippingSaint ? data.shipmentstatus : '- - -'}</td>
                                                                <td>{data.carrier ? data.carrier : '- - -'}</td>
                                                                <td>{data.itemtitle  ? data.itemtitle : '- - -'}</td>
                                                                <td>{data.notes ? data.notes : '- - -'}</td>
                                                            
                                                            </tr>
                                                        ) : 
                                                        <tr><td colSpan="10"><h5 className="noData" >No data available</h5></td></tr>
                                                }
                                            </tbody>
                                        </Table>
                                    }
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div> :
                            <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                                <h4>No Data found</h4>
                            </div>
                }
            </div>
        );
    }
}
